//PJQAddressBook-Master
var tbSearch = null,
	tbLocation = null,
	tbMain = null,
	tbScreen = null,
	gridMain = null,
	gridContactErrors = null,
	dlgContactErrors = null,
	settings = null,
	cmCompany = null,
	cmContact = null,
	pjqKeepAlive = null,
	treeGroupFilter = null,
	gridGroupFilter = null,
	selectedRows = '',
	lastFilter = '',
	gridMainView = 'contact',
	filteredGroups = '',
	gridMainSortOrder = 'CompanyName',
	gridMainSortDirection = 'asc',
	gridMainSortIndex = 0,
	gridMainNextView = '',
	validator = null,
	gridMainLastSelectedRow = 0,
	gridMainLastPage = 0,
	lastContactId = null,
	lastContactIdView = '',
	selectedCompanies = [],
	selectedContacts = [],
	selectedGroups = [],
	isAdvSearch = false,
	gridContactHistoryMain = null,
	directoryDefaultText = ["All", "Private Only", "Public Only"],
	locationDefaultText = ["Work Area", "Office Location"],
	currentDirectoryFilter = 1,
	currentLocationFilter = 1,
	selectAllCount = 0,
	isBlankSearch = false,
	isShowVendors = true,
	isShowArchitects = false,
	isShowOwners = false,
	isShowUnion = false,
	isShowNonUnion = false,
	isShowPrevailing = false,
	lastScreeningCommentId = null,
	pjqProjectMsgContext = null;

let $addressBookEl = null;

function initAddressBook($el) {
	treeGroupFilter = null;
	$addressBookEl = $el;
	pjqKeepAlive = setTimeout(KeepAlive, 300000);
	settings = {};
	settings.AddressBookContext = pjqABContext;
	if (settings.IsDirectory)
		currentDirectoryFilter = 0;
	settings.Project = {
		ProjectName: '',
		City: '',
		StateProvince: '',
		PostalCode: ''
	};
	settings.ProjContainer = {
		ProjectContainerName: '',
		City: '',
		StateProvince: '',
		PostalCode: ''
	};
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, 'Master', {
		isOldModule: true,
		isJsRender: true
	}), $el, settings, function () {
		ShowBusy("Starting Up...");

		if (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.AB_STATS_TAB_ID)) {
			$el.prepend($('<iframe/>', {
				src: '/Default.aspx?tabid=' + PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.AB_STATS_TAB_ID).toString(),
				style: 'border:0;width:100%;height:30px;'
			}));
		}

		PanteraScript.PanteraScriptService.GetAddressBookSettings(pjqSessionId, GetSettingsC, onScriptError);
	});
}

function pjqDL(id) {
	PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'files',
			value: id
		},
		{
			endpoint: 'downloadentryid'
		}
	]), {
		isEndpoint: true,
		isApi2: true
	});
	return false;
}


function SetInputStyles(id) {
	jQuery("input,select,textarea", jQuery(id)).css('font-family', 'tahoma').css('font-size', '10pt');
}

function EnableToolbars(enabled) {
	if (!tbMain || !tbSearch)
		return;

	if (enabled) {

		if (!isAdvSearch) {
			tbSearch.tryEnableItem('search_for');
			tbLocation.tryEnableItem('zip');
			tbLocation.tryEnableItem('radius');
			tbSearch.tryEnableItem('groups');
			tbSearch.tryEnableItem('search');
		}
		if (settings.IsDirectory)
			tbSearch.tryEnableItem('directory');
		tbSearch.tryEnableItem('adv_search');
		tbSearch.tryEnableItem('clear');
		tbSearch.tryEnableItem('export');
		tbMain.tryEnableItem('view_company');
		tbMain.tryEnableItem('view_contact');
		tbMain.tryEnableItem('view_group');
		tbMain.tryDisableItem('edit');
		tbMain.tryEnableItem('merge');
		tbMain.tryEnableItem('cancelMerge');
		tbMain.tryEnableItem('deleteMultiple');
		tbMain.tryEnableItem('cancelDeleteMultiple');
		tbMain.tryEnableItem('import');
		tbMain.tryEnableItem('show_owners');
		tbMain.tryEnableItem('show_architects');
		tbMain.tryEnableItem('show_vendors');
		if (!settings.IsHideUnionStatus || currentDirectoryFilter != 1) {
			tbMain.tryEnableItem('show_union');
			tbMain.tryEnableItem('show_nonunion');
			tbMain.tryEnableItem('show_prevailing');
		}
		if (!settings.IsRO)
			tbMain.tryEnableItem('new');

		try {
			if (settings.IsApprovalRequired)
				tbMain.tryEnableItem('view_approval_default');
		} catch (err) {
		}

	}
	else {
		tbSearch.tryDisableItem('search_for');
		tbLocation.tryDisableItem('zip');
		tbLocation.tryDisableItem('radius');
		tbSearch.tryDisableItem('groups');
		tbSearch.tryDisableItem('search');
		tbSearch.tryDisableItem('adv_search');
		tbSearch.tryDisableItem('clear');
		tbSearch.tryDisableItem('directory');
		tbSearch.tryDisableItem('export');
		tbMain.tryDisableItem('view_company');
		tbMain.tryDisableItem('view_contact');
		tbMain.tryDisableItem('view_group');
		tbMain.tryDisableItem('edit');
		tbMain.tryDisableItem('new');
		tbMain.tryDisableItem('merge');
		tbMain.tryDisableItem('cancelMerge');
		tbMain.tryDisableItem('deleteMultiple');
		tbMain.tryDisableItem('cancelDeleteMultiple');
		tbMain.tryDisableItem('import');
		tbMain.tryDisableItem('show_owners');
		tbMain.tryDisableItem('show_architects');
		tbMain.tryDisableItem('show_vendors');
		if (!settings.IsHideUnionStatus || currentDirectoryFilter != 1) {
			tbMain.tryDisableItem('show_union');
			tbMain.tryDisableItem('show_nonunion');
			tbMain.tryDisableItem('show_prevailing');
		}
		try {
			if (settings.IsApprovalRequired)
				tbMain.tryDisableItem('view_approval_default');
		} catch (err) {
		}
	}
}

function GetAdvSearchC(response) {
	advSearch = response; //jQuery.parseJSON(response);
	advSearch.IsCrossStateBoundaries = true;

	jQuery.extend(true, advSearch, settings);

	if (jQuery('#divAdvSearch').html().trim().length == 0 && settings.AddressBookContext == 'ap3') {
		advSearch.SearchZip = tbLocation.getValue('zip');
		var radius = tbLocation.getListOptionSelected('radius');
		advSearch.SearchRadius = parseInt(radius.substring(radius.indexOf('_') + 1));
		advSearch.GroupIdList = filteredGroups;
	}

	jQuery("#divGrid").addClass('pjq-hidden');
	let template = 'AdvancedSearch',
		sessionMasterUserId = PJQ.app.session.get('masterUserId');
	if (sessionMasterUserId === 59174) {
		template += '_59174';
	}
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, template, {
		isOldModule: true,
		isJsRender: true
	}), jQuery("#divAdvSearch"), advSearch, function () {
		SetInputStyles("#divAdvSearch");
		jQuery("#divAdvSearch").removeClass('pjq-hidden');

		if (typeof InitializeAdvancedSearch == 'function')
			InitializeAdvancedSearch(advSearch);
	});
}

function GetAdvSearchC2(response) {
	advSearch = response; //jQuery.parseJSON(response);
	jQuery.extend(true, advSearch, settings);

	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, 'AdvancedSearch', {
		isOldModule: true,
		isJsRender: true
	}), jQuery("#divAdvSearch"), advSearch, function () {
		SetInputStyles("#divAdvSearch");
		if (typeof InitializeAdvancedSearch == 'function')
			InitializeAdvancedSearch(advSearch);
	});
}

function ReturnToWall() {
	var url = null;
	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL) && settings.AddressBookContext === 'pccf') {
		let src = PJQ.helpers.urlHelpers.getQueryParam('src');
		if (_.size(src) > 0 && src.toString().toLowerCase() === "p") {
			url = "/#projects/" + settings.Project.ProjectId.toString() + '/mall';
		}
	}

	if (_.size(url) === 0) {
		if (settings.AddressBookContext !== 'pccf' && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL)) {
			let queryString = window.location.search.substring(1),
				params = queryString.split('&'),
				isNewMessage = false;
			for (let i = 0; i < params.length; i++) {
				if (params[i].startsWith('newmsg=')) {
					isNewMessage = true;
					break;
				}
			}
			if (isNewMessage) {
				url = "/#projects/" + settings.Project.ProjectId.toString() + '/messaging/context/' + pjqProjectMsgContext + '/' + pjqSessionId + '/new';
			}
			else {
				url = "/#projects/" + settings.Project.ProjectId.toString() + '/messaging/context/' + pjqProjectMsgContext + '/' + pjqSessionId;
			}
		}
		else {
			url = '/Default.aspx?tabId=' + settings.ProjectWallAdminTabId.toString() + '&s=' + pjqSessionId;

			var queryString = window.location.search.substring(1);
			var params = queryString.split('&');
			for (var i = 0; i < params.length; i++) {
				if (params[i].startsWith('v=') && !pjqIsAddProjectContacts)
					url += '&' + params[i];
				else if (params[i].startsWith('pccfid='))
					url += '&' + params[i];
				else if (params[i].startsWith('pcfid='))
					url += '&' + params[i];
				else if (params[i].startsWith('newmsg='))
					url += '&' + params[i];
			}

			if (pjqIsAddProjectContacts) {
				url += '&pcr=true';
			}
			else {
				if (settings.AddressBookContext == 'ap2' || settings.AddressBookContext == 'ap3') {
					url += '&pct=' + pjqProjectMsgContext;

				}
				else if (settings.AddressBookContext == 'pccf') {
					url += '&pccf=1';
					if (pjqProjContainerId != '0' && pjqProjectId == '0')
						url += '&projcontainerid=' + pjqProjContainerId;
				}
				else if (settings.AddressBookContext == 'pcf') {
					url += '&pcf=1';
				}
			}
		}
	}

	window.location.href = url;
}

function AddSelectedContacts(callback) {
	if (pjqIsAddProjectContacts) {
		PanteraScript.PanteraScriptService.AddProjectManagementContacts(pjqSessionId, selectedCompanies.join(','), selectedContacts.join(','), selectedGroups.join(','), callback ? callback : ReturnToWall, onScriptError);
	}
	else if (pjqABContext == 'ap2' || settings.AddressBookContext == 'ap2' || settings.AddressBookContext == 'ap3') {
		ShowBusy("Adding Contacts...");
		PanteraScript.PanteraScriptService.SetProjectCompanyContactGroups(pjqSessionId, selectedCompanies.join(','), selectedContacts.join(','), selectedGroups.join(','), function () {
			AddProjectContacts(callback);
		}, onScriptError);
	}
	else if (pjqABContext == 'pccf') {
		ShowBusy("Adding Contacts...");
		var queryString = window.location.search.substring(1);
		var params = queryString.split('&');
		var pccfid = '';
		for (var i = 0; i < params.length; i++) {
			if (params[i].startsWith('pccfid=')) {
				pccfid = params[i].substring(7);
			}
		}

		PanteraScript.PanteraScriptService.AddProjectContainerCustomFieldContacts(pjqSessionId, parseInt(pccfid), selectedCompanies.join(','), selectedContacts.join(','), callback ? callback : ReturnToWall, onScriptError);
	}
	else if (pjqABContext == 'pcf') {
		ShowBusy("Adding Contacts...");
		var queryString = window.location.search.substring(1);
		var params = queryString.split('&');
		var pcfid = '';
		for (var i = 0; i < params.length; i++) {
			if (params[i].startsWith('pcfid=')) {
				pcfid = params[i].substring(6);
			}
		}

		PanteraScript.PanteraScriptService.AddProjectCustomFieldContacts(pjqSessionId, parseInt(pcfid), selectedCompanies.join(','), selectedContacts.join(','), callback ? callback : ReturnToWall, onScriptError);
	}
}

function AddProjectContacts(callback) {
	gridContactErrors = new dhtmlXGridObject('missing-data');
	gridContactErrors.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	gridContactErrors.enableMultiline(true);
	gridContactErrors.setSkin(pjqGridTheme);
	jQuery('#missing-data').css('width', '100%');
	gridContactErrors.enableAutoHeight(true, 400);
	gridContactErrors.enableAutoWidth(true);
	gridContactErrors.setHeader("Company,Contact,Phone,Ext,Reason");
	gridContactErrors.setInitWidthsP("30,20,15,10,23");
	gridContactErrors.setColAlign("left,left,left,left,left");
	gridContactErrors.setColTypes("ro,ro,ro,ro,ro");
	gridContactErrors.setColSorting("str,str,str,str,str");
	gridContactErrors.attachEvent("onRowDblClicked", function (id, ind) {
		var contactId = gridContactErrors.getUserData(id, "ContactId");
		jQuery(dlgContactErrors).dialog('close');
		getContactInfo(parseInt(contactId));
	});
	gridContactErrors.init();
	gridContactErrors.loadXML('/DesktopModules/PJQAddressBook/CheckPCCG.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
		if (gridContactErrors.getRowsNum() > 0) {
			HideBusy();
			jQuery('#missing-data-header').html('There are ' + gridContactErrors.getRowsNum().toString() + ' contacts that cannot receive messages.  You can edit a Contact by double-clicking it.<br />Click "Continue" to continue without adding these contacts.');
			dlgContactErrors = jQuery("#dialog-missing-data").dialog({
				resizable: false,
				height: 600,
				width: 800,
				title: 'Add Contacts',
				modal: true,
				draggable: false,
				buttons: {
					"Continue": function () {
						jQuery(this).dialog('close');
						ShowBusy("Adding Contacts...");
						PanteraScript.PanteraScriptService.AddProjectCompanyContactGroups(pjqSessionId, selectedCompanies.join(','), selectedContacts.join(','), selectedGroups.join(','), callback ? callback : ReturnToWall, onScriptError);
					},
					"Export List": function () {
						DownloadFile('/DesktopModules/PJQAddressBook/CheckPCCG.aspx?sessionid=' + pjqSessionId + '&xlsxfmt=1&x=' + (new Date).getTime());

					},
					"Clear Selections": function () {
						jQuery(this).dialog('close');
						selectedCompanies = [];
						selectedContacts = [];
						selectedGroups = [];
						InitializeGridMain(gridMainView);
					}
				}
			});
		}
		else {
			if (pjqIsAddProjectContacts)
				PanteraScript.PanteraScriptService.AddProjectManagementContacts(pjqSessionId, selectedCompanies.join(','), selectedContacts.join(','), selectedGroups.join(','), callback ? callback : ReturnToWall, onScriptError);
			else
				PanteraScript.PanteraScriptService.AddProjectCompanyContactGroups(pjqSessionId, selectedCompanies.join(','), selectedContacts.join(','), selectedGroups.join(','), callback ? callback : ReturnToWall, onScriptError);
		}
	});
}

function GetSettingsC(response) {
	settings = jQuery.parseJSON(response);
	settings.AddressBookContext = pjqABContext;

	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS)) {
		settings.IsRO = settings.IsDD = !PJQ.app.session.hasPermission('contacts.isAdmin');
		settings.CanExport = PJQ.app.session.hasPermission('contacts.canExport');
		settings.CanImport = PJQ.app.session.hasPermission('contacts.canImport');
		settings.CanApprove = PJQ.app.session.hasPermission('contacts.canApprove');
		settings.CanViewApproval = PJQ.app.session.hasPermission('contacts.canViewApproval');
	}
	else {
		settings.CanExport = true;
		settings.CanImport = true;
		settings.CanApprove = settings.IsApprovalRequired;
	}

	if (window.location.href.toLowerCase().indexOf('proqualverified') != -1)
		settings.IsRegionsMapEnabled = true;

	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, 'Master', {
		isOldModule: true,
		isJsRender: true
	}), $addressBookEl, settings, function () {
		SetInputStyles("#pjq-main");

		if (PJQ.app.module === PJQ.constants.modules.APP) {
			if (settings.FieldMappingGroup != null) {
				window.pjqABFMGroup = settings.FieldMappingGroup;
			}
			if (settings.FieldMappingCompany != null) {
				window.pjqABFMCompany = settings.FieldMappingCompany;
			}
			if (settings.FieldMappingContact != null) {
				window.pjqABFMContact = settings.FieldMappingContact;
			}
		}

		validator = jQuery("Form[name='Form']").validate({
			onsubmit: false,
			onkeyup: false,
			showErrors: function (errorMap, errorList) {
				for (var i = 0; errorList[i]; i++) {
					var element = this.errorList[i].element;
					this.errorsFor(element).remove();
				}
				this.defaultShowErrors();
			},
			errorPlacement: function (error, element) {
				error.html('<br />' + error.text());
				if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
					error.appendTo(element.parent().parent());
				else
					error.appendTo(element.parent());
			},
			errorClass: "pjq-errortext",
			ignore: "pjq-validate-ignore"
		});
		if (settings.PagerPosition && settings.PagerPosition == 'top' && !settings.IsEnableSecondPaging)
			jQuery('#grid-main-container').prepend(jQuery('#grid-main-paging'));

		tbSearch = new dhtmlXToolbarObject("main-search");
		tbSearch.setSkin("dhx_web");
		tbSearch.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		tbSearch.addText("search_label", 0, "<b>Search:</b>");
		tbSearch.addInput('search_for', 1, '', 175);
		tbSearch.addSeparator("search_sep", 2);

		tbSearch.addButton("groups", 12, "All Trades", "", "");
		tbSearch.setItemText("groups", "All " + settings.GroupLabel);

		if (settings.IsDirectory) {
			tbSearch.addSeparator("directory_sep", 13);
			tbSearch.addText('directory_label', 14, '<b>Show:</b>');
			tbSearch.addButtonSelect("directory", 15, '', [
				['directory_0', 'obj', 'All', ''],
				['directory_1', 'obj', 'Private Only', ''],
				['directory_2', 'obj', 'Public Only', '']
			]);
			tbSearch.setListOptionSelected('directory', 'directory_' + settings.DefaultDisplayDirectory);
			tbSearch.setItemText('directory', directoryDefaultText[settings.DefaultDisplayDirectory]);
		}

		tbSearch.addSeparator("search_sep", 16);
		tbSearch.addButton("search", 17, "Search", "action_search.gif", "");
		tbSearch.addSeparator("adv_search_sep", 18);
		tbSearch.addButton("adv_search", 19, "Advanced Search", "filter.gif", "");
		tbSearch.addSeparator("clear_sep", 20);
		tbSearch.addButton("clear", 21, "Clear Search", "cancel_search.gif", "");
		tbSearch.addSeparator("left_sep", 22);

		if (PJQ.app.module !== PJQ.constants.modules.APP && !window.isHideAddSelectedContacts && (settings.AddressBookContext == 'ap2' || settings.AddressBookContext == 'ap3')) {
			tbSearch.addButton("add_contacts", 23, "Add Selected Participants", "AddContact.png", "");
		}
		else if (PJQ.app.module !== PJQ.constants.modules.APP && (settings.AddressBookContext == 'pccf' || settings.AddressBookContext == 'pcf')) {
			tbSearch.addSpacer("left_sep");
			tbSearch.addButton("add_contacts", 23, "Add Selected Contacts", "AddContact.png", "");
		}
		else if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS)) {
			if (!settings.IsRO && !settings.IsExportHidden && !window.isHideImportExport) {
				tbSearch.addSpacer("left_sep");
				tbSearch.addButton("import", 23, "Import Contacts", "Excel.jpg", "ExcelD.jpg");
				tbSearch.addSeparator("import_sep", 25);
				tbSearch.addButton("export", 26, "Export Contacts", "Excel.jpg", "ExcelD.jpg");
			}
		}
		else if ((settings.CanExport || settings.CanImport) && !window.isHideImportExport) {
			if (settings.CanImport) {
				tbSearch.addSpacer("left_sep");
				tbSearch.addButton("import", 23, "Import Contacts", "Excel.jpg", "ExcelD.jpg");
			}
			if (settings.CanExport && !settings.IsExportHidden) {
				if (!settings.CanImport) {
					tbSearch.addSpacer("left_sep");
				}
				if (settings.CanImport) {
					tbSearch.addSeparator("import_sep", 25);
				}
				tbSearch.addButton("export", 26, "Export Contacts", "Excel.jpg", "ExcelD.jpg");
			}
		}

		if (settings.AddressBookContext == 'ap3') {
			if (settings.DefaultSearchZip)
				tbLocation.setValue('zip', settings.DefaultSearchZip);
			if (settings.DefaultSearchRadius) {
				tbLocation.setListOptionSelected('radius', 'radius_' + settings.DefaultSearchRadius.toString());
				tbLocation.setItemText('radius', settings.DefaultSearchRadius.toString() + ' miles');
			}
			if (settings.DefaultGroupIdList) {
				filteredGroups = settings.DefaultGroupIdList;
				var groupCount = settings.DefaultGroupIdList.split(',').length;
				tbSearch.setItemText("groups", groupCount.toString() + " " + settings.GroupLabel);
			}
		}

		jQuery('input.inp', '#main-search').keypress(function (event) {
			if (event.which == 13) {
				event.preventDefault();
				InitializeGridMain(gridMainView);
			}
		});

		tbSearch.attachEvent("onClick", function (id) {
			if (id.startsWith('directory')) {
				if (id.indexOf('_') > 0) {
					let label = directoryDefaultText[parseInt(id.substring(id.indexOf('_') + 1))];
					tbSearch.setItemText('directory', label);
					DirectoryFilterChanged();
					InitializeGridMain(gridMainView);
				}
			}
			else if (id === 'import') {
				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_CONTACT_IMPORT)) {
					new PJQ.views.contacts.ContactsImportModal()
				}
				else {
					InitAddressBookImportDialog();
				}
			}
			else if (id === 'export') {
				ShowBusy("Exporting...");
				var xmlFile = '';

				if (gridMainView == 'company') {
					xmlFile = '/DesktopModules/PJQAddressBook/GetCompanies' + '.aspx?view=company&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
				}
				else if (gridMainView == 'contact') {
					xmlFile = '/DesktopModules/PJQAddressBook/GetContacts' + '.aspx?view=contact&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
				}
				else if (gridMainView == 'group') {
					xmlFile = '/DesktopModules/PJQAddressBook/GetContacts' + '.aspx?view=contact&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
					xmlFile += '&bygroup=1';
				}
				if (pjqABContext.length > 0)
					xmlFile += '&cb=1';

				else if (pjqABContext == 'merge')
					xmlFile += '&merge=1';

				else if (pjqABContext == 'deleteMultiple')
					xmlFile += '&deleteMultiple=1';

				if (pjqABContext == 'scr')
					xmlFile += '&scr=1';

				var unionFilter = getUnionFilter(),
					contactTypeFilter = getContactTypeFilter();
				if (unionFilter.length > 0) {
					xmlFile += '&misc=' + unionFilter;
				}
				if (contactTypeFilter.length > 0) {
					xmlFile += '&ctf=' + contactTypeFilter;
				}

				if (settings.IsApprovalRequired) {
					if (tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
						xmlFile += '&sflt=SELFADD_APPROVAL_NEEDED';
					}
				}

				if (isAdvSearch) {
					if (advSearch && advSearch.AddressBookSearchId != '00000000-0000-0000-0000-000000000000')
						xmlFile += '&adv=' + advSearch.AddressBookSearchId;
					else if (advSearch && advSearch.AddressBookSearchTempId != '00000000-0000-0000-0000-000000000000')
						xmlFile += '&advt=' + advSearch.AddressBookSearchTempId;
				}

				xmlFile += '&excel=1';

				jQuery.ajax({
					url: xmlFile,
					success: function (result) {
						HideBusy();
						showInfoDialogAB('Export Complete', '<a href="' + result + '">Click here to download your export.</a>', 'ui-icon-info');
					},
					error: function (xhr, status, error) {
						HideBusy();
						showInfoDialogAB('Export Error', "An error occurred during export: " + error, 'ui-icon-alert');
					}
				});
			}
			else if (id == 'add_contacts') {
				if (selectedCompanies.length + selectedContacts.length + selectedGroups.length == 0) {
					showInfoDialogAB('No Records Selected', "Please select record(s) before clicking 'Add Selected Participants'", 'ui-icon-alert');
					return;
				}

				if (selectedCompanies.length + selectedContacts.length + selectedGroups.length > 10000) {
					showInfoDialogAB('Large Selection', "Note: You have too many contacts and groups selected at one time. ");

					return;
				}
				AddSelectedContacts();
			}
			else if (id == 'adv_search') {
				if (jQuery('#divAdvSearch').html().trim().length == 0)
					GetAdvancedSearch(settings.DefaultAddressBookSearchId);
				//PanteraScript.PanteraScriptService.GetAdvancedSearchAB(pjqSessionId, settings.DefaultAddressBookSearchId, GetAdvSearchC, onScriptError);
				else {
					jQuery('#divGrid').addClass('pjq-hidden');
					jQuery('#divAdvSearch').removeClass('pjq-hidden');
				}
			}
			else if (id == 'search') {
				tbSearch.setItemText('adv_search', 'Advanced Search');
				isAdvSearch = false;
				InitializeGridMain(gridMainView);
			}
			else if (id == 'clear') {
				tbSearch.setItemText('adv_search', 'Advanced Search');
				isAdvSearch = false;
				tbSearch.setValue('search_for', '', false);
				tbLocation.setValue('zip', '', false);
				tbLocation.setListOptionSelected('radius', 'radius_0');
				tbLocation.setItemText('radius', '0 Miles');
				tbSearch.setItemText("groups", "All " + settings.GroupLabel);
				filteredGroups = '';
				if ((settings.GroupLevel > 1 || (currentDirectoryFilter != 1 && !settings.HasGroupsLinked)) && treeGroupFilter != null) {
					treeGroupFilter.setSubChecked('0', false);
					treeGroupFilter.setCheck('NONE', false);

				}
				else if (gridGroupFilter != null)
					gridGroupFilter.setCheckedRows(0, 0);

				tbSearch.tryEnableItem('search_for');
				tbLocation.tryEnableItem('zip');
				tbLocation.tryEnableItem('radius');
				tbSearch.tryEnableItem('groups');
				tbSearch.tryEnableItem('search');
				tbMain.setItemState('show_union', false);
				tbMain.setItemState('show_nonunion', false);
				tbMain.setItemState('show_prevailing', false);
				selectedCompanies = [];
				selectedContacts = [];
				selectedGroups = [];

				GetAdvancedSearch('00000000-0000-0000-0000-000000000000', GetAdvSearchC2);
				//PanteraScript.PanteraScriptService.GetAdvancedSearchAB(pjqSessionId, '00000000-0000-0000-0000-000000000000', GetAdvSearchC2, onScriptError);

				InitializeGridMain(gridMainView);
			}
			else if (id == 'groups') {
				var groupContainerHeight = 0;
				var gridGroupHeight = 0;
				var treeGroupHeight = 0;
				if (currentDirectoryFilter == 0) {
					gridGroupHeight = 375;
					treeGroupHeight = 425;
					groupContainerHeight = 425;
				}
				else {
					gridGroupHeight = 425;
					treeGroupHeight = 475;
					groupContainerHeight = 480;
				}
				if ((settings.GroupLevel > 1 && (currentDirectoryFilter != 0 || settings.HasGroupsLinked)) || (currentDirectoryFilter == 2 && !settings.HasGroupsLinked)) {
					jQuery('#filterGroupButtonsetContainer').hide();
					jQuery('#grid-group-filter').hide();
					jQuery('#tree-group-filter').show();
					var directoryGroupFilter = '';
					if (settings.IsDirectory && !settings.HasGroupsLinked && currentDirectoryFilter != 1) {
						directoryGroupFilter = currentDirectoryFilter.toString();
					}
					if (treeGroupFilter == null) {
						ShowBusy('Loading...');
						treeGroupFilter = new dhtmlXTreeObject("tree-group-filter", "100%", "100%", 0);
						treeGroupFilter.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
						treeGroupFilter.enableCheckBoxes(1);
						treeGroupFilter.enableMultiLineItems("300px");
						treeGroupFilter.enableTreeLines(false);
						treeGroupFilter.enableTreeImages(false);
						jQuery('#tree-group-filter').height(treeGroupHeight);
						treeGroupFilter.setOnClickHandler(treeContactGroupsclick);
						treeGroupFilter.setDataMode('json');
						treeGroupFilter.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTree.aspx?sessionid=' + pjqSessionId + '&nogroup=1' + '&x=' + (new Date).getTime() + (directoryGroupFilter.length > 0 ? ("&dir=" + directoryGroupFilter) : ""), function () {
							jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().css('display', 'none');
							jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().next().css('padding-left', '2px');
							HideBusy();
						});

						treeGroupFilter.attachEvent("onCheck", function (id, state) {
							if (treeGroupFilter.getLevel(id) == 1) {
								var groupSubItems = treeGroupFilter.getAllSubItems(id).split(',');
								for (var i = 0; i < groupSubItems.length; i++) {
									treeGroupFilter.setCheck(groupSubItems[i], state);
								}
							}
						})
					}
					else {
						treeGroupFilter.deleteChildItems(0);
						treeGroupFilter.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTree.aspx?sessionid=' + pjqSessionId + '&nogroup=1' + '&x=' + (new Date).getTime() + (directoryGroupFilter.length > 0 ? ("&dir=" + directoryGroupFilter) : ""), function () {
							jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().css('display', 'none');
							jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().next().css('padding-left', '2px');
						});
					}
				}
				else if ((settings.GroupLevel <= 1) && (currentDirectoryFilter == 1 || currentDirectoryFilter == 0 || !settings.IsDirectory || settings.HasGroupsLinked)) {
					jQuery('#tree-group-filter').hide();
					jQuery('#filterGroupButtonsetContainer').hide();
					jQuery('#grid-group-filter').show();
					if (gridGroupFilter == null) {
						ShowBusy('Loading...');
						gridGroupFilter = new dhtmlXGridObject('grid-group-filter');
						gridGroupFilter.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
						gridGroupFilter.enableMultiline(true);
						gridGroupFilter.setSkin(pjqGridTheme);
						gridGroupFilter.setHeader("&nbsp;," + settings.GroupLabel + ",Contacts");
						gridGroupFilter.setInitWidthsP("6,94");
						gridGroupFilter.setColAlign("center,left,center");
						gridGroupFilter.setColTypes("ch,ro,ro");
						gridGroupFilter.setColSorting("na,na,na");
						gridGroupFilter.enableTooltips("false,true,false");
						jQuery('#groupFilterContainer').height(groupContainerHeight);
						gridGroupFilter.enableAutoHeight(true, gridGroupHeight);
						gridGroupFilter.init();
						var groups = filteredGroups.split(',');
						gridGroupFilter.loadXML('/DesktopModules/PJQAddressBook/GetGroupList.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
							gridGroupFilter.forEachRow(function (id) {
								if (jQuery.inArray(id, groups) !== -1)
									gridGroupFilter.cells(id, 0).setChecked(true);
							});
							HideBusy();
						});
					}
					else {
						jQuery('#groupFilterContainer').height(groupContainerHeight);
						gridGroupFilter.enableAutoHeight(true, gridGroupHeight);
						gridGroupFilter.setSizes();
					}
				}
				if (currentDirectoryFilter == 0 && !settings.HasGroupsLinked) {
					jQuery('label[for="groupsFilterPrivate"]').text('Private ' + settings.GroupLabel);
					jQuery('label[for="groupsFilterDirectory"]').text('Directory ' + settings.GroupLabel);
					jQuery('#filterGroupButtonset').buttonset();
					jQuery('#groupsFilterPrivate, #groupsFilterDirectory').off();
					jQuery('#groupsFilterPrivate, #groupsFilterDirectory').on('change', function () {
						var gridGroupHeight = 375;
						var treeGroupHeight = 425;
						var groupContainerHeight = 425;
						var directoryGroupFilterAll = '';
						if (jQuery('#groupsFilterDirectory').prop('checked')) {
							directoryGroupFilterAll = currentDirectoryFilter.toString();
						}
						if (settings.GroupLevel > 1) {
							if (treeGroupFilter == null) {
								ShowBusy('Loading...');
								treeGroupFilter = new dhtmlXTreeObject("tree-group-filter", "100%", "100%", 0);
								treeGroupFilter.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
								if (settings.IsDirectory)
									treeGroupFilter.enableCheckBoxes(0);
								treeGroupFilter.enableCheckBoxes(1);
								treeGroupFilter.enableMultiLineItems("300px");
								treeGroupFilter.enableTreeLines(false);
								treeGroupFilter.enableTreeImages(false);
								treeGroupFilter.setOnClickHandler(treeContactGroupsclick);
								treeGroupFilter.setDataMode('json');
								treeGroupFilter.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTree.aspx?sessionid=' + pjqSessionId + '&nogroup=1' + '&x=' + (new Date).getTime() + (directoryGroupFilterAll.length > 0 ? ("&dir=" + directoryGroupFilterAll) : ""), function () {
									jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().css('display', 'none');
									jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().next().css('padding-left', '2px');
									HideBusy();
									jQuery('#grid-group-filter').hide();
									jQuery('#tree-group-filter').show();
								});
								treeGroupFilter.attachEvent("onCheck", function (id, state) {
									if (treeGroupFilter.getLevel(id) == 1) {
										var groupSubItems = treeGroupFilter.getAllSubItems(id).split(',');
										for (var i = 0; i < groupSubItems.length; i++) {
											treeGroupFilter.setCheck(groupSubItems[i], state);
										}
									}
								})
							}
							else {
								treeGroupFilter.deleteChildItems(0);
								treeGroupFilter.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTree.aspx?sessionid=' + pjqSessionId + '&nogroup=1' + '&x=' + (new Date).getTime() + (directoryGroupFilterAll.length > 0 ? ("&dir=" + directoryGroupFilterAll) : ""), function () {
									jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().css('display', 'none');
									jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().next().css('padding-left', '2px');
									HideBusy();
									jQuery('#grid-group-filter').hide();
									jQuery('#tree-group-filter').show();
								});
							}
							if (currentDirectoryFilter == 0) {
								gridGroupHeight = 375;
								groupContainerHeight = 425;
							}
							else {
								gridGroupHeight = 425;
								groupContainerHeight = 480;
							}
						}
						else {
							if (jQuery('#groupsFilterPrivate').prop('checked')) {
								jQuery('#tree-group-filter').hide();
								jQuery('#grid-group-filter').show();
							}
							else {
								jQuery('#grid-group-filter').hide();
								jQuery('#tree-group-filter').show();
								if (treeGroupFilter == null) {
									ShowBusy('Loading...');
									treeGroupFilter = new dhtmlXTreeObject("tree-group-filter", "100%", "100%", 0);
									treeGroupFilter.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
									treeGroupFilter.enableCheckBoxes(1);
									treeGroupFilter.enableMultiLineItems("300px");
									treeGroupFilter.enableTreeLines(false);
									treeGroupFilter.enableTreeImages(false);
									treeGroupFilter.setOnClickHandler(treeContactGroupsclick);
									treeGroupFilter.setDataMode('json');
									treeGroupFilter.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTree.aspx?sessionid=' + pjqSessionId + '&nogroup=1' + '&x=' + (new Date).getTime() + (directoryGroupFilterAll.length > 0 ? ("&dir=" + directoryGroupFilterAll) : ""), function () {
										jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().css('display', 'none');
										jQuery('#tree-group-filter div table tbody tr td table tbody tr td img').first().parent().next().css('padding-left', '2px');
										HideBusy();
									});
									treeGroupFilter.attachEvent("onCheck", function (id, state) {
										if (treeGroupFilter.getLevel(id) == 1) {
											var groupSubItems = treeGroupFilter.getAllSubItems(id).split(',');
											for (var i = 0; i < groupSubItems.length; i++) {
												treeGroupFilter.setCheck(groupSubItems[i], state);
											}
										}
									})
								}
							}
						}
						jQuery('#tree-group-filter').height(treeGroupHeight);
					});
					jQuery('#groupsFilterPrivate').prop('checked', true).trigger('change').button('refresh');
					jQuery('#filterGroupButtonsetContainer').show();
				}

				var dlg = jQuery("#dialog-filter-groups").dialog({
					resizable: false,
					height: 600,
					dialogClass: 'dialog-filter-groups',
					width: 800,
					title: 'Filter ' + settings.GroupLabel,
					modal: true,
					draggable: false,
					buttons: {
						"Check All": function () {
							if (settings.GroupLevel > 1 || (currentDirectoryFilter != 1 && !settings.HasGroupsLinked))
								treeGroupFilter.setSubChecked('0', true);
							else
								gridGroupFilter.setCheckedRows(0, 1);
						},
						"Clear All": function () {
							if (settings.GroupLevel > 1 || (currentDirectoryFilter != 1 && !settings.HasGroupsLinked))
								treeGroupFilter.setSubChecked('0', false);
							else
								gridGroupFilter.setCheckedRows(0, 0);
						},
						"Filter": function () {
							let filteredGroupsArr = [];
							if (treeGroupFilter != null && (settings.GroupLevel > 1 || (currentDirectoryFilter === 0 && !settings.HasGroupsLinked) || currentDirectoryFilter === 2)) {
								let groupTreeString = treeGroupFilter.getAllChecked();
								if (_.size(groupTreeString) > 0) {
									filteredGroupsArr = _.union(filteredGroupsArr, _.filter(_.map(groupTreeString.split(','), function (id) {
										return parseInt(id.replace(new RegExp('_.*'), '').replace('NONE', 0));
									}), function (id) {
										return id > -1;
									}));
								}
							}
							if (gridGroupFilter != null && settings.GroupLevel < 2) {
								let groupGridString = gridGroupFilter.getCheckedRows(0);
								if (_.size(groupGridString) > 0) {
									filteredGroupsArr = _.union(filteredGroupsArr, _.filter(_.map(groupGridString.split(','), function (id) {
										return parseInt(id.replace(new RegExp('_.*'), '').replace('NONE', 0));
									}), function (id) {
										return id > -1;
									}));
								}
							}

							filteredGroups = filteredGroupsArr.join(',');
							let itemCount = _.size(filteredGroupsArr);
							if (itemCount === 0)
								tbSearch.setItemText("groups", "All " + settings.GroupLabel);
							else
								tbSearch.setItemText("groups", itemCount.toString() + " " + settings.GroupLabel);

							InitializeGridMain(gridMainView);
							$(this).dialog('close');
						}
					}
				});

			}
		});

		tbLocation = new dhtmlXToolbarObject("location-toolbar");
		tbLocation.setSkin("dhx_web");
		tbLocation.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		if (settings.IsRegionsMapEnabled) {
			tbLocation.addText("location_label", 1, "<b>Location Type:</b>");
			tbLocation.addButtonSelect("location", 2, '', [
				['location_0', 'obj', locationDefaultText[0], ''],
				['location_1', 'obj', locationDefaultText[1], '']
			]);
			currentLocationFilter = settings.DefaultLocationFilter;
			tbLocation.setListOptionSelected('location', 'location_' + currentLocationFilter);
			tbLocation.setItemText('location', locationDefaultText[currentLocationFilter]);
			tbLocation.addSeparator("location_sep", 5);
		}
		tbLocation.addText('zip_label', 3, '<b>Zip:</b>');
		tbLocation.addInput('zip', 4, '', 75);
		tbLocation.addSeparator("radius_sep", 5);
		tbLocation.addText('radius_label', 6, '<b>Radius:</b>');
		var radiusOpts = Array(Array('radius_0', 'obj', '0 Miles', ''), Array('radius_10', 'obj', '10 Miles', ''), Array('radius_15', 'obj', '15 Miles', ''), Array('radius_25', 'obj', '25 Miles', ''), Array('radius_50', 'obj', '50 Miles', ''), Array('radius_75', 'obj', '75 Miles', ''), Array('radius_100', 'obj', '100 Miles', ''), Array('radius_125', 'obj', '125 Miles', ''), Array('radius_150', 'obj', '150 Miles', ''), Array('radius_175', 'obj', '175 Miles', ''), Array('radius_200', 'obj', '200 Miles', ''), Array('radius_225', 'obj', '225 Miles', ''), Array('radius_250', 'obj', '250 Miles', ''), Array('radius_275', 'obj', '275 Miles', ''), Array('radius_300', 'obj', '300 Miles', ''));
		tbLocation.addButtonSelect("radius", 7, "0 Miles", radiusOpts, "", "");
		tbLocation.setListOptionSelected('radius', 'radius_0');
		tbLocation.addSeparator("end_sep", 8);

		tbLocation.attachEvent("onClick", function (id) {
			if (id.startsWith('radius')) {
				if (id.indexOf('_') > 0) {
					let label = id.substring(id.indexOf('_') + 1) + ' Miles';
					tbLocation.setItemText('radius', label);
				}
			}
			else if (id.startsWith('location_')) {
				let label = locationDefaultText[parseInt(id.substring(id.indexOf('_') + 1))];
				tbLocation.setItemText('location', label);
				LocationFilterChanged();
			}
		});

		tbMain = new dhtmlXToolbarObject("main-toolbar");
		tbMain.setSkin("dhx_web");
		tbMain.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		if (!settings.IsHideContactType) {
			tbMain.addText('contact_type_label', 0, '<b>Contact Type:</b>');

			if (settings.ContactTypes.length === 0) {
				tbMain.addButtonTwoState('show_owners', 2, '[Owners]');
				tbMain.addButtonTwoState('show_architects', 3, '[Architects]');
				tbMain.addButtonTwoState('show_vendors', 4, '[Vendors]');
				tbMain.setItemState('show_vendors', true);
			}
			else {
				let options = [], defaultTypeName = '', defaultTypeId = 0;

				_.each(settings.ContactTypes, function (type) {
					if (type.IsDefault) {
						defaultTypeName = type.UserTypeName;
						defaultTypeId = type.UserTypeId;

					}

					options.push(['usertype_' + type.UserTypeId, 'obj', type.UserTypeName, '']);
				});

				tbMain.addButtonSelect("usertype", 2, defaultTypeName, options);
				tbMain.setListOptionSelected('usertype', 'usertype_' + defaultTypeId);
			}
		}

		tbMain.addSeparator('view_sep', 5);
		tbMain.addText('view_label', 6, '<b>View by:</b>');
		if (settings.DefaultView == 'view_contact')
			tbMain.addButtonTwoState('view_contact', 8, '[Contact]');
		else if (settings.DefaultView == 'view_company')
			tbMain.addButtonTwoState('view_company', 8, '[Company]');
		else if (settings.DefaultView == 'view_group')
			tbMain.addButtonTwoState('view_group', 8, '[' + settings.GroupLabel + ']');

		tbMain.setItemState(settings.DefaultView, true);

		if (settings.DefaultView == 'view_contact') {
			tbMain.addButtonTwoState('view_company', 10, '[Company]');
			tbMain.addButtonTwoState('view_group', 12, '[' + settings.GroupLabel + ']');
		}
		else if (settings.DefaultView == 'view_company') {
			tbMain.addButtonTwoState('view_contact', 10, '[Contact]');
			tbMain.addButtonTwoState('view_group', 12, '[' + settings.GroupLabel + ']');
		}
		else if (settings.DefaultView == 'view_group') {
			tbMain.addButtonTwoState('view_contact', 10, '[Contact]');
			tbMain.addButtonTwoState('view_company', 12, '[Company]');
		}
		tbMain.addText('labor_label', 13, '<b>Labor:</b>');
		tbMain.addButtonTwoState('show_union', 14, '[Union]');
		tbMain.addButtonTwoState('show_nonunion', 15, '[Non-Union]');
		tbMain.addButtonTwoState('show_prevailing', 16, '[Prev. Wage]');
		if (!settings.IsHideUnionStatus) {
			tbMain.tryHideItem('labor_label');
			tbMain.tryHideItem('show_union');
			tbMain.tryHideItem('show_nonunion');
			tbMain.tryHideItem('show_prevailing');
		}

		tbMain.addSeparator('left_sep', 17);

		var editLabel = 'Edit Record';
		if (settings.IsRO)
			editLabel = 'View Record';

		tbMain.addButton("edit", 18, editLabel, "edit.jpg", "editD.jpg");
		tbMain.tryDisableItem("edit");

		tbMain.addSeparator("new_sep", 19);
		tbMain.addButton("new", 20, "New Record", "add_page.gif", "add_pageD.gif");
		if (settings.IsRO)
			tbMain.tryDisableItem("new");

		if (settings.IsAllowMassDelete) {
			tbMain.addSeparator("deleteMultiple_sep", 22);
			tbMain.addButton("deleteMultiple", 24, "Delete Records", "action_delete.gif", "action_deleteD.gif");
			tbMain.addSeparator("cancelDeleteMultiple_sep", 26);
			tbMain.addButton("cancelDeleteMultiple", 28, "Cancel Delete", "action_delete.gif", "action_deleteD.gif");
			tbMain.tryHideItem('cancelDeleteMultiple');
			tbMain.tryHideItem('cancelDeleteMultiple_sep');
			tbMain.tryHideItem('deleteMultiple');
			tbMain.tryHideItem('deleteMultiple_sep');
			tbMain.tryHideItem('cancelDeleteMultiple');
			tbMain.tryHideItem('cancelDeleteMultiple_sep');
		}

		tbMain.addSeparator("end_sep", 30);

		if (!window.isHideReturnToProject && (settings.AddressBookContext == 'ap2' || settings.AddressBookContext == 'ap3' || settings.AddressBookContext == 'pcf')) {

			tbMain.addSpacer("end_sep");
			tbMain.addSeparator("return_wall", 32);
			tbMain.addButton("return_wall", 34, "Return to Project", "redo.gif", "");
		}
		else if (settings.AddressBookContext == 'pccf') {
			tbMain.addSpacer("end_sep");
			tbMain.addSeparator("return_wall", 32);
			tbMain.addButton("return_wall", 34, "Return to " + settings.ProjContainerLabel, "redo.gif", "");
		}
		else if (settings.IsApprovalRequired && (settings.CanApprove || settings.CanViewApproval || settings.isApprovalEditEnabled)) {
			if (PJQ.app.module === PJQ.constants.modules.APP) {
				window.$addressBookEl.prepend('<div><img src="/i/worker.png" alt="Address Book">&nbsp;Address Book:&nbsp;<a href="javascript:void(0)" onclick="viewApproval()" style="color:red;">' + settings.CountNeedsApproval.toString() + ' Unapproved</a></div>');
			}

			tbMain.addSpacer("end_sep");
			tbMain.addSeparator("view_approval_sep", 32);
			var approvalOpts = [];
			approvalOpts.push(['view_approved', 'obj', "Approved", '']);
			approvalOpts.push(['view_needs_approval', 'obj', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")", '']);
			tbMain.addButtonSelect("view_approval_default", 34, "Approved", approvalOpts, "group.gif");
			tbMain.setListOptionSelected('view_approval_default', approvalOpts[0][0]);

			if (PJQ.helpers.urlHelpers.getQueryParam("approval") && settings.CountNeedsApproval > 0) {
				tbMain.setListOptionSelected('view_approval_default', approvalOpts[1][0]);
				tbMain.setItemText("view_approval_default", "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
			}

			if (settings.CountNeedsApproval == 0)
				tbMain.disableListOption('view_approval_default', 'view_needs_approval');

			if (!window.isHideMerge) {
				tbMain.addSeparator("merge_sep", 36);
				tbMain.addButton("merge", 38, "Merge Contacts", "Merge.png", "MergeD.png");
				tbMain.addSeparator("cancelMerge_sep", 23);
				tbMain.addButton("cancelMerge", 40, "Cancel Merge", "Merge.png", "MergeD.png");
				tbMain.tryHideItem('cancelMerge');
				tbMain.tryHideItem('cancelMerge_sep');
				tbMain.addSpacer("end_sep");
			}
		}
		else if (!settings.IsRO && !window.isHideMerge) {
			tbMain.addSeparator("merge_sep", 46);
			tbMain.addButton("merge", 48, "Merge Contacts", "Merge.png", "MergeD.png");
			tbMain.addSeparator("cancelMerge_sep", 50);
			tbMain.addButton("cancelMerge", 52, "Cancel Merge", "Merge.png", "MergeD.png");
			tbMain.tryHideItem('cancelMerge');
			tbMain.tryHideItem('cancelMerge_sep');
			tbMain.addSpacer("end_sep");
		}

		if (settings.IsDirectory) {
			//Call this now so we can hide/show the correct search options
			DirectoryFilterChanged();
		}

		tbMain.attachEvent("onClick", function (id) {
			if (id == 'new') {
				tbMain.tryDisableItem('new');
				jQuery('html,body').scrollTop(0);
				getNewContact();
			}
			else if (id == 'edit') {
				var contactId = lastContactId;
				jQuery('html,body').scrollTop(0);
				getContactInfo(parseInt(contactId));
			}
			else if (id == 'return_wall') {
				ReturnToWall();
			}
			else if (id == 'merge') {
				if (pjqABContext == 'merge') {
					PanteraScript.PanteraScriptService.GetContactInfoMerge(pjqSessionId, selectedContacts.join('|'), InitMergeContactsHelper, onScriptError);
				}
				else
					InitMergeContactsGridMain();
			}
			else if (id == 'cancelMerge') {
				CancelMergeContactsGridMain();
			}
			else if (id == 'deleteMultiple') {
				if (pjqABContext == 'deleteMultiple') {
					var deleteText = '';
					if (gridMainView == 'company') {
						if (selectedContacts.length > 1)
							deleteText = 'Are you sure you want to delete these companies?<br /> <br />NOTE: All Contacts of this Company will also be deleted, including ones that may not be visible due to filters.';
						else
							deleteText = 'Are you sure you want to delete this company?<br /> <br />NOTE: All Contacts of this Company will also be deleted, including ones that may not be visible due to filters.'
					}
					else {
						if (selectedContacts.length > 1)
							deleteText = 'Are you sure you want to delete these contacts? (' + selectedContacts.length + ' contacts selected)';
						else
							deleteText = 'Are you sure you want to delete this contact?';
					}
					showInfoDialogAB('Delete Confirmation', deleteText, 'ui-icon-alert', 'delete-contacts-multiple');
				}
				else {
					tbMain.tryDisableItem('deleteMultiple');
					InitDeleteMultipleContactsGridMain();
				}
			}
			else if (id == 'cancelDeleteMultiple') {
				CancelDeleteMultipleContactsGridMain();
			}
			else if (id == 'view_approved') {
				tbMain.setItemText('view_approval_default', 'Approved');
				InitializeGridMain(gridMainView);
			}
			else if (id == 'view_needs_approval') {
				tbMain.setItemText('view_approval_default', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
				InitializeGridMain(gridMainView);
			}
			else if (id.startsWith('usertype_')) {
				let userTypeId = id.substring(id.indexOf('_') + 1);
				_.each(settings.ContactTypes, function (type) {
					if (type.UserTypeId == parseInt(userTypeId)) {
						tbMain.setItemText('usertype', type.UserTypeName);
					}
				});
				InitializeGridMain(gridMainView);
			}
		});

		tbMain.attachEvent("onStateChange", function (id, state) {
			if (id.indexOf('view_') != -1) {
				gridMainNextView = id;
				if (settings.AddressBookContext != '' && selectedCompanies.length + selectedContacts.length + selectedGroups.length > 0) {
					showInfoDialogAB('Contacts Selected', 'Warning: Switching Views will clear your checkbox selections.  Do you want to continue?', 'ui-icon-alert', 'main-view');
				}
				else {
					InitializeGrid();
				}
			}
			else {
				if (id == 'show_owners') {
					isShowOwners = state;
					if (!tbMain.getItemState('show_architects') && !tbMain.getItemState('show_vendors') && !state) {
						tbMain.setItemState('show_owners', true);
						isShowOwners = true;
					}
					tbMain.setItemState('show_architects', false);
					tbMain.setItemState('show_vendors', false);
					isShowArchitects = false;
					isShowVendors = false;
					InitializeGridMain(gridMainView);
				}
				else if (id == 'show_architects') {
					isShowArchitects = state;
					if (!tbMain.getItemState('show_owners') && !tbMain.getItemState('show_vendors') && !state) {
						tbMain.setItemState('show_architects', true);
						isShowArchitects = true;
					}
					tbMain.setItemState('show_owners', false);
					tbMain.setItemState('show_vendors', false);
					isShowOwners = false;
					isShowVendors = false;
					InitializeGridMain(gridMainView);
				}
				else if (id == 'show_vendors') {
					isShowVendors = state;
					if (!tbMain.getItemState('show_owners') && !tbMain.getItemState('show_architects') && !state) {
						tbMain.setItemState('show_vendors', true);
						isShowVendors = true;
					}
					tbMain.setItemState('show_owners', false);
					tbMain.setItemState('show_architects', false);
					isShowOwners = false;
					isShowArchitects = false;
					InitializeGridMain(gridMainView);
				}
				else if (id == 'show_union') {
					isShowUnion = state;
					InitializeGridMain(gridMainView);
				}
				else if (id == 'show_nonunion') {
					isShowNonUnion = state;
					InitializeGridMain(gridMainView);
				}
				else if (id == 'show_prevailing') {
					isShowPrevailing = state;
					InitializeGridMain(gridMainView);
				}
			}
		});

		if (cmCompany)
			cmCompany.hideContextMenu();

		if (cmContact)
			cmContact.hideContextMenu();

		var verb = 'Edit'
		if (settings.IsRO)
			verb = 'View';
		cmCompany = new dhtmlXMenuObject();
		cmCompany.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
		cmCompany.addNewChild(cmCompany.topId, 1, "edit", verb + " Record", false, "edit.jpg");
		//cmCompany.addNewChild(cmCompany.topId, 2, "history", "View History", false, "history.png");
		if (settings.CanExport) {
			cmCompany.addNewChild(cmCompany.topId, 3, "excel", "Export Excel", false, "excel.jpg");
		}
		//if (settings.IsContactUpdaterEnabled)
		//    cmCompany.addNewChild(cmCompany.topId, 4, "updater", "Send Updater", false, "resend2.png");
		if (!settings.IsRO && !settings.IsDD)
			cmCompany.addNewChild(cmCompany.topId, 2, "delete", "Delete Record", false, "action_delete.gif");
		if (settings.IsDirectory) {
			cmCompany.addNewChild(cmCompany.topId, 6, "report", "Report", false, "report.gif");
			cmCompany.addNewChild(cmCompany.topId, 8, "copyDirectory", "Copy", false, "copy.gif");
		}

		cmCompany.addNewChild(cmCompany.topId, 7, "requestPrequal", "Request Prequal", false, "resend2.png");

		cmCompany.addNewChild(cmCompany.topId, 9, "vcard", "Export vCard", false, "ico_contact.gif");
		cmCompany.addNewChild(cmCompany.topId, 10, "projectHistory", "Project History", false, "history.png");
		cmCompany.attachEvent("onClick", cmClick);
		cmCompany.renderAsContextMenu();


		cmContact = new dhtmlXMenuObject();
		cmContact.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
		cmContact.addNewChild(cmContact.topId, 1, "edit", verb + " Contact", false, "edit.jpg");
		if (settings.CanExport) {
			cmContact.addNewChild(cmContact.topId, 2, "excel", "Export Excel", false, "excel.jpg");
		}
		if (settings.IsContactUpdaterEnabled)
			cmContact.addNewChild(cmContact.topId, 3, "updater", "Send Updater", false, "resend2.png");
		if (settings.IsApprovalRequired && (settings.IsApprovalEditEnabled || settings.CanApprove))
			cmContact.addNewChild(cmContact.topId, 4, "approve", "Approve Contact", false, "");
		if (settings.IsDirectory) {
			cmContact.addNewChild(cmContact.topId, 5, "report", "Report", false, "report.gif");
			cmContact.addNewChild(cmCompany.topId, 7, "copyDirectory", "Copy", false, "copy.gif");
		}

		cmContact.addNewChild(cmContact.topId, 6, "requestPrequal", "Request Prequal", false, "resend2.png");

		if (!settings.IsRO && !settings.IsDD)
			cmContact.addNewChild(cmContact.topId, 10, "delete", "Delete Contact", false, "action_delete.gif");

		cmContact.addNewChild(cmContact.topId, 11, "vcard", "Export vCard", false, "ico_contact.gif");

		cmContact.addNewChild(cmContact.topId, 12, "projectHistory", "Project History", false, "history.png");
		cmContact.attachEvent("onClick", cmClick);
		cmContact.renderAsContextMenu();

		if (gridMainView == 'company')
			gridMainSortIndex = 1;
		else if (gridMainView == 'contact')
			gridMainSortIndex = 0;
		else if (gridMainView == 'group')
			gridMainSortIndex = 1;

		var parts;
		if (gridMainView == 'company') {
			parts = pjqABFMCompany;
			parts = parts.split(',');
			parts = parts[gridMainSortIndex].split('|')[3];
		}
		else if (gridMainView == 'contact') {
			parts = pjqABFMContact;
			parts = parts.split(',');
			parts = parts[gridMainSortIndex].split('|')[3];
		}
		else if (gridMainView == 'group') {
			parts = pjqABFMGroup;
			parts = parts.split(',');
			parts = parts[gridMainSortIndex].split('|')[3];
		}
		if (parts == 'na')
			gridMainSortIndex++;

		settings.ApprovalLevelCol = null;

		if (pjqABContext.length > 0 && gridMainView != 'group') {
			if (gridMainView == 'contact')
				gridMainSortIndex += 1;
			gridMainSortIndex += 1;
		}

		gridMainNextView = settings.DefaultView;

		if (settings.IsPreQual) {
			initScreeningFilters();

			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'screenings'
					},
					{
						endpoint: 'packages'
					},
				]),
				isPascal: true
			}).get().done(_.bind(function (data) {
				settings.ScreeningPackages = data;
			}, this));
		}

		if (pjqABContext != '' && pjqABContext != 'pccf' && pjqABContext != 'pcf') {
			var pcURL = "/DesktopModules/PJQAddressBook/GetProjectContacts.aspx?sessionId=" + pjqSessionId + "&x=" + (new Date).getTime();
			if (pjqIsAddProjectContacts)
				pcURL += "&pc=true";
			$.getJSON(pcURL, function (data) {
				settings.DisabledRows = data.d.DisabledRows;
				settings.DisabledRowsCount = data.d.DisabledRows.length;
				LoadNextView();
			});
		}
		else
			LoadNextView();

		if (PJQ.helpers.urlHelpers.getQueryParam('ecw') != null)
			getContactInfo(parseInt(PJQ.helpers.urlHelpers.getQueryParam('ecw')));
		if (typeof AddressBookInitializedOverride == 'function')
			AddressBookInitializedOverride();
	});
}


function InitializeGrid() {
	selectedCompanies = [];
	selectedContacts = [];
	selectedGroups = [];
	gridMainSortDirection = 'asc';
	LoadNextView();
}

function LoadNextView() {

	if (gridMainView == 'company')
		gridMainSortIndex = 1;
	else if (gridMainView == 'contact')
		gridMainSortIndex = 0;
	else if (gridMainView == 'group')
		gridMainSortIndex = 1;

	var parts;
	var fullParts;
	if (gridMainView == 'company') {
		parts = pjqABFMCompany;
		parts = parts.split(',');
		fullParts = parts;
		parts = parts[gridMainSortIndex].split('|')[3];
	}
	else if (gridMainView == 'contact') {
		parts = pjqABFMContact;
		parts = parts.split(',');
		fullParts = parts;
		parts = parts[gridMainSortIndex].split('|')[3];
	}
	else if (gridMainView == 'group') {
		parts = pjqABFMGroup;
		parts = parts.split(',');
		fullParts = parts;
		parts = parts[gridMainSortIndex].split('|')[3];
	}

	if (gridMainNextView == 'view_company') {
		tbMain.setItemState('view_company', true);
		tbMain.setItemState('view_contact', false);
		tbMain.setItemState('view_group', false);
		gridMainSortIndex = 0;


		if (parts == 'na')
			gridMainSortIndex++;


		if (pjqABContext.length > 0)
			gridMainSortIndex++;

		InitializeGridMain('company');
	}
	else if (gridMainNextView == 'view_contact') {
		tbMain.setItemState('view_company', false);
		tbMain.setItemState('view_contact', true);
		tbMain.setItemState('view_group', false);
		gridMainSortIndex = 1;


		if (parts == 'na')
			gridMainSortIndex++;

		if (pjqABContext.length > 0)
			gridMainSortIndex += 2;
		InitializeGridMain('contact');
	}
	else if (gridMainNextView == 'view_group') {
		tbMain.setItemState('view_company', false);
		tbMain.setItemState('view_contact', false);
		tbMain.setItemState('view_group', true);
		gridMainSortIndex = 1;

		if (parts == 'na')
			gridMainSortIndex++;

		InitializeGridMain('group');
	}
}

function cmClick(id, zoneId, casState) {
	if (id == 'edit') {
		jQuery('html,body').scrollTop(0);
		getContactInfo(parseInt(lastContactId));
	}
	else if (id == 'history') {
		gridContactHistoryMain = new dhtmlXGridObject('contact-history-main');
		gridContactHistoryMain.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
		gridContactHistoryMain.enableMultiline(true);
		gridContactHistoryMain.setSkin(pjqGridTheme);

		jQuery('#contact-history-main').css('width', '100%');
		gridContactHistoryMain.enableAutoWidth(true);
		gridContactHistoryMain.enableAutoHeight(true, 575);
		gridContactHistoryMain.setNoHeader(true);
		gridContactHistoryMain.init();
		gridContactHistoryMain.attachEvent("onRowSelect", function (id, ind) {
			var ps = gridContactHistoryMain.getUserData(id, "ProjectStatus");
			var projectId = parseInt(gridContactHistoryMain.getUserData(id, "ProjectId"));
			if (projectId > 0 && (ps != 'ARCHIVE' && ps != 'DELETED')) {
				window.location.href = '/Default.aspx?tabId=' + settings.ProjectWallAdminTabId.toString() + '&projectid=' + projectId.toString();
			}
		});
		gridContactHistoryMain.loadXML('/DesktopModules/PJQAddressBook/GetContactHistory.aspx?sessionid=' + pjqSessionId + '&c=' + lastContactId.toString() + '&x=' + (new Date).getTime(), function () {
			if (gridContactHistoryMain.getRowsNum() == 0) {
				gridContactHistoryMain.destructor();
				jQuery('#contact-history-main').html("<div class='ui-state-highlight ui-corner-all pjq-notice' style='height: 40px;'><p><span class='ui-icon ui-icon-info'></span><span>There is no History for this Contact.</span></p></div>");
			}
			var dlg = jQuery("#dialog-contact-history").dialog({
				resizable: false,
				height: 650,
				width: 800,
				title: 'Contact History',
				modal: true,
				draggable: false,
				buttons: {}
			});
		});
	}
	else if (id == 'excel') {
		PanteraScript.PanteraScriptService.ExportContactXLS(pjqSessionId, parseInt(lastContactId), ExportCC, onScriptError);
	}
	else if (id == 'delete') {
		if (lastContactIdView == 'company')
			showInfoDialogAB('Delete Confirmation', 'Are you sure you want to delete this Company?  NOTE: All Contacts of this Company will also be deleted, including ones that may not be visible due to filters.', 'ui-icon-alert', 'delete-contact');
		else {
			var message = 'Are you sure you want to delete this Contact?';
			if (settings.IsPreQual)
				message = 'WARNING: The contact you are about to delete may be associated with a Qualification Package.  If you delete this contact, the Qualification Package and all associated data will also be deleted.  Are you sure you still want to delete this contact?';
			showInfoDialogAB('Delete Confirmation', message, 'ui-icon-alert', 'delete-contact');
		}
	}
	else if (id == 'approve') {
		showInfoDialogAB('Approval Confirmation', 'Are you sure you want to approve all Edits to this Contact?', 'ui-icon-alert', 'approve-contact');
	}
	else if (id == 'updater') {
		showInfoDialogAB('Send Contact Updater', 'Are you sure you want to send this contact an Update Request?', 'ui-icon-alert', 'contact-updater');
	}
	else if (id == 'report') {
		InitReportContactDialog();
	}
	else if (id == 'copyDirectory') {
		copyDirectoryContact(lastContactId);
	}
	else if (id == 'requestPrequal') {
		RequestContactPrequalificationHelper(lastContactId);
	}
	else if (id == 'projectHistory') {

		var xmlFile = '/DesktopModules/PJQAddressBook/GetContactHistory.aspx?sessionid=' + pjqSessionId + '&c=' + lastContactId + '&view=projectmain&x=' + (new Date).getTime();
		//PanteraScript.PanteraScriptService.GetContactProjectStatusHistory(pjqSessionId, parseInt(lastContactId), , onScriptError);

		jQuery.ajax({
			type: "GET",
			url: xmlFile,
			dataType: "text",
			success: function (result) {
				GetContactProjectStatusHistoryAbC(result);
			}
		});

	}
	else if (id == 'vcard') {
		GetVCard(lastContactId);
	}
}

function SendContactUpdater() {
	PanteraScript.PanteraScriptService.ResendContactUpdater(pjqSessionId, parseInt(lastContactId), ContactUpdateC, onScriptError);
}

function ContactUpdateC() {
}

function ExportCC(response) {
	showInfoDialogAB('Export Complete', '<a href="' + response + '">Click here to download your export.</a>', 'ui-icon-info');
}

function GridResized() {
	jQuery('#grid-main').css('width', '100%');
	gridMain.setSizes();
}

function RefreshGridMain() {
	var xmlFile = '';

	if (gridMainView == 'company') {
		xmlFile = '/DesktopModules/PJQAddressBook/GetCompanies' + '.aspx?view=company&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
	}
	else if (gridMainView == 'contact') {
		xmlFile = '/DesktopModules/PJQAddressBook/GetContacts' + '.aspx?view=contact&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
	}
	else if (gridMainView == 'group') {
		xmlFile = '/DesktopModules/PJQAddressBook/GetGroups' + '.aspx?view=groups&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
	}

	if (pjqABContext == 'scr')
		xmlFile += '&scr=1';

	if (settings.IsDirectory)
		xmlFile += ('&dir=' + currentDirectoryFilter);

	var unionFilter = getUnionFilter(),
		contactTypeFilter = getContactTypeFilter();
	if (unionFilter.length > 0) {
		xmlFile += '&misc=' + unionFilter;
	}
	if (contactTypeFilter.length > 0) {
		xmlFile += '&ctf=' + contactTypeFilter;
	}

	if (pjqABContext.length > 0)
		xmlFile += '&cb=1';

	else if (pjqABContext == 'merge')
		xmlFile += '&merge=1';

	else if (pjqABContext == 'deleteMultiple')
		xmlFile += '&deleteMultiple=1';

	if (isAdvSearch) {
		if (advSearch && advSearch.AddressBookSearchId != '00000000-0000-0000-0000-000000000000')
			xmlFile += '&adv=' + advSearch.AddressBookSearchId;
		else if (advSearch && advSearch.AddressBookSearchTempId != '00000000-0000-0000-0000-000000000000')
			xmlFile += '&advt=' + advSearch.AddressBookSearchTempId;
	}

	gridMain.clearAll();
	gridMain.loadXML(xmlFile, function () {

		if (pjqABContext.length > 0)
			jQuery('div.xhdr table.hdr td:nth-child(1)').addClass('centerme');

		tbMain.tryDisableItem('edit');

		gridMain.setSortImgState(true, gridMainSortIndex, gridMainSortDirection);
	});
}


function InitializeGridMain(view) {
	gridMainView = view;
	gridMainNextView = '';
	gridMain = new dhtmlXGridObject('grid-main');
	gridMain.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');

	var isMultiline = true;
	if (window.location.href.toLowerCase().indexOf('proqualverified') != -1 ||
		window.location.href.toLowerCase().indexOf('andresprequal') != -1 ||
		window.location.href.toLowerCase().indexOf('prequal.hwgc') != -1 ||
		window.location.href.toLowerCase().indexOf('vandelayplanroom') != -1)
		isMultiline = false;

	gridMain.enableMultiline(isMultiline);
	gridMain.setSkin(pjqGridTheme);

	jQuery('#grid-main-paging').removeClass('pjq-hidden');
	jQuery('#grid-main-paging2').removeClass('pjq-hidden');
	var paging2 = null;
	if (settings.IsEnableSecondPaging)
		paging2 = 'grid-main-paging2';
	gridMain.enablePaging(true, settings.RowsPerPage, 3, "grid-main-paging", true, null, paging2);
	gridMain.setPagingSkin("toolbar", 'dhx_web');


	gridMain.attachEvent("onBeforePageChanged", function () {
		if (!this.getRowsNum())
			return false;
		return true;
	});

	gridMain.attachEvent("onPageChanged", function (ind, fInd, lInd) {
		jQuery(window).scrollTop(0);
		return true;
	});

	gridMain.sortRows = function (col, type, order) {
	};


	if (pjqABContext.length == 0)
		tbSearch.tryEnableItem('export');

	if (gridMainView == 'company')
		gridMain.enableContextMenu(cmCompany);
	else if (gridMainView == 'contact')
		gridMain.enableContextMenu(cmContact);

	gridMain.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		lastContactId = id;
		lastContactIdView = gridMainView;
		obj.selectRowById(id);
		cmCompany.hideContextMenu();
		cmContact.hideContextMenu();

		var isDirectoryContact = (gridMain.getUserData(id, "IsDirectoryContact") == 'true');
		if (gridMainView == 'contact') {
			if (gridMain.getUserData(id, 'IsPrimaryContact') == 'true') {
				if (!settings.IsRO && !settings.IsDD)
					cmContact.showItem('delete');
				else
					cmContact.hideItem('delete');
			}
			else {
				if (!settings.IsRO && !settings.IsDD)
					cmContact.showItem('delete');
				else
					cmContact.hideItem('delete');
			}

			if (isDirectoryContact || currentDirectoryFilter == 2)
				cmContact.showItem('copyDirectory');
			else
				cmContact.hideItem('copyDirectory');
			if ((isDirectoryContact || currentDirectoryFilter == 2) || settings.IsEnableReportPrivateContact)
				cmContact.showItem('report');
			else
				cmContact.hideItem('report');

			if (isDirectoryContact)
				cmContact.hideItem('delete');

		}
		else if (gridMainView == 'company') {

			if (isDirectoryContact || currentDirectoryFilter == 2)
				cmCompany.showItem('copyDirectory');
			else
				cmCompany.hideItem('copyDirectory');
			if ((isDirectoryContact || currentDirectoryFilter == 2) || settings.IsEnableReportPrivateContact)
				cmCompany.showItem('report');
			else
				cmCompany.hideItem('report');

			if (isDirectoryContact)
				cmCompany.hideItem('delete');

		}
		else {
			if (isDirectoryContact || currentDirectoryFilter == 2)
				cmContact.showItem('copyDirectory');
			else
				cmContact.hideItem('copyDirectory');
			if ((isDirectoryContact || currentDirectoryFilter == 2) || settings.IsEnableReportPrivateContact)
				cmContact.showItem('report');
			else
				cmContact.hideItem('report');
		}

		if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove)) {
			cmContact.hideItem('edit');
			cmContact.hideItem('delete');
		}
		else {
			cmContact.showItem('edit');

			if (!settings.IsRO && !settings.IsDD && !isDirectoryContact)
				cmContact.showItem('delete');
		}

		if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (settings.IsApprovalEditEnabled || settings.CanApprove))
			cmContact.showItem('approve');
		else if (settings.IsApprovalRequired)
			cmContact.hideItem('approve');

		if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove)) {
			cmCompany.hideItem('edit');
			cmCompany.hideItem('delete');
		}
		else {
			cmCompany.showItem('edit');

			if (!settings.IsRO && !settings.IsDD && !isDirectoryContact)
				cmCompany.showItem('delete');
		}

		return true;
	});


	jQuery('#grid-main').css('width', '100%');
	gridMain.enableAutoHeight(true);

	//note: 2016-12-19 enabling auto width causes grid rendering issues in IE11
	//gridMain.enableAutoWidth(true);

	gridMain.attachEvent("onXLS", function (grid_obj) {
		ShowBusy("Loading...");
	});
	gridMain.attachEvent("onXLE", function (grid_obj) {
		HideBusy();

		var parts;
		var fullParts;
		if (gridMainView == 'company') {
			parts = pjqABFMCompany;
			parts = parts.split(',');
			fullParts = parts;
		}
		else if (gridMainView == 'contact') {
			parts = pjqABFMContact;
			parts = parts.split(',');
			fullParts = parts;
		}
		else if (gridMainView == 'group') {
			parts = pjqABFMGroup;
			parts = parts.split(',');
			fullParts = parts;
		}

		settings.ApprovalLevelCol = null;
		if (settings.IsColorApprovalColumn) {
			for (var i = 0; i < fullParts.length; i++) {
				if (fullParts[i].toLowerCase().indexOf('approval level') != -1 || fullParts[i].toLowerCase().indexOf('final grade') != -1) {
					settings.ApprovalLevelCol = i + 1;
				}
			}
		}

		gridMain.forEachRow(gridMainXLE);
		if (gridMainLastSelectedRow != 0 && gridMain.doesRowExist(gridMainLastSelectedRow.toString())) {

			if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
				if (settings.IsApprovalEditEnabled || settings.canApprove)
					tbMain.tryEnableItem('edit');
				else
					tbMain.tryDisableItem('edit');
			}
			else
				tbMain.tryEnableItem('edit');

			gridMain.selectRowById(gridMainLastSelectedRow.toString());
			if (gridMainView == 'group') {
				setTimeout(function () {
					var wat = gridMainLastSelectedRow;
					gridMain.cells(wat.toString(), 0).open();
					gridMainLastSelectedRow = 0;
				}, 10);
			}
			else
				gridMainLastSelectedRow = 0;
		}

		setTimeout(function () {
			jQuery('input.inp', '#main-search').first().focus();
		}, 200);

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_COLOR_COLUMNS)) {
			let colorCodePref = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_COLOR_COLUMNS),
				colorCols = $.parseJSON(colorCodePref),
				colorCol = 0;
			if (gridMainView == 'company') {
				colorCol = colorCols.main.company;
			}
			else if (gridMainView == 'contact') {
				colorCol = colorCols.main.contact;
			}
			if (settings.AddressBookContext == 'ap2' || settings.AddressBookContext == 'ap3') {
				colorCol = colorCols.main.projectContext;
			}
			gridMain.forEachRow(function (id) {
				if (gridMainView == 'company' || gridMainView == 'contact') {
					let rowColor = gridMain.cells(id, colorCol).getValue().toLowerCase();
					switch (rowColor) {
						case 'green':
							gridMain.setRowColor(id, '#37DA5E');
							break;
						case 'blue':
							gridMain.setRowColor(id, '#A2ADF9');
							break;
						case 'red':
							gridMain.setRowColor(id, '#F57C7C');
							break;
						case 'yellow':
							gridMain.setRowColor(id, '#FCFF80');
							break;
						case 'purple':
							gridMain.setRowColor(id, '#E4A0E0');
							break;
						case 'orange':
							gridMain.setRowColor(id, '#FC8');
							break;
					}
				}
			});
		}
	});

	gridMain.init();
	dhtmlxEvent(window, "resize", function () {
		jQuery('#grid-main, #grid-main div table').css('width', '100%');
		jQuery('#grid-main div table tbody tr th').css('width', '');
		jQuery('#edit-contact-groups, #edit-contact-regions, #grid-contacts').css('width', '100%');
		jQuery('#edit-contact-groups div table, #edit-contact-regions div table, #grid-contacts div table').css('width', '100%');
		jQuery('#edit-contact-groups div table tbody tr th, #edit-contact-regions div table tbody tr th, #grid-contacts div table tbody tr th').css('width', '');
		gridMain.setSizes();
		if (gridContacts)
			gridContacts.setSizes();
		if (gridContactGroups)
			gridContactGroups.setSizes();
		if (gridContactRegions)
			gridContactRegions.setSizes();
	});

	gridMain.attachEvent("onRowDblClicked", function (id, ind) {
		var contactId = gridMain.getSelectedRowId();
		if (gridMainView == 'group') {
			return;
		}

		if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove))
			return;

		getContactInfo(parseInt(contactId));
	});

	gridMain.attachEvent("onRowSelect", function (id, ind) {
		if (gridMainView == 'group')
			tbMain.tryDisableItem('edit');
		else {
			lastContactId = id;

			if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
				if (settings.IsApprovalEditEnabled || settings.CanApprove)
					tbMain.tryEnableItem('edit');
				else
					tbMain.tryDisableItem('edit');
			}
			else
				tbMain.tryEnableItem('edit');
		}

		gridMain.forEachRow(function (id2) {

			var subgrid;
			if (gridMain.cells(id2, 0).getSubGrid && (gridMainView == 'group' || settings.AddressBookContext == '')) {
				subgrid = gridMain.cells(id2, 0).getSubGrid();
			}
			else if (gridMain.cells(id2, 1).getSubGrid)
				subgrid = gridMain.cells(id2, 1).getSubGrid();

			if (subgrid) {
				subgrid.clearSelection();
			}
		});


		if (gridMain.getColLabel(ind).toLowerCase().indexOf('email') > -1) {
			if (gridMain.cell.innerText && gridMain.cell.innerText.length > 0) {
				window.location.href = 'mailto:' + gridMain.cell.innerText;
			}
		}

	});

	gridMain.attachEvent("onCheck", function (rId, cInd, state) {
		if (gridMainView != 'group') {
			if (state) {
				if (gridMainView == 'contact') {
					if (pjqABContext == 'scr' || pjqABContext == 'merge' || pjqABContext == 'pccf' || pjqABContext == 'pcf' || pjqABContext == 'deleteMultiple') {
						AddIfMissing(selectedContacts, rId);
					}
					else {
						var groupIds = gridMain.getUserData(rId, 'GroupIdList');
						if (groupIds)
							AddIfMissing(selectedGroups, gridMain.getUserData(rId, 'GroupIdList'));
						else
							AddIfMissing(selectedContacts, rId);
					}
				}
				else {
					if (pjqABContext == 'scr')
						AddIfMissing(selectedContacts, gridMain.getUserData(rId, 'DefaultContactId'));
					else if (pjqABContext == 'merge' || pjqABContext == 'pccf' || pjqABContext == 'pcf' || pjqABContext == 'deleteMultiple') {
						AddIfMissing(selectedContacts, gridMain.getUserData(rId, 'SelectableContacts'));
					}
					else {
						AddIfMissing(selectedGroups, gridMain.getUserData(rId, 'GroupIdList'));
						if (filteredGroups.trim().length == 0 && filteredGroups.split(',').indexOf('0') == -1)
							AddIfMissing(selectedContacts, gridMain.getUserData(rId, 'NoGroupContactIdList'));
					}
				}
			}
			else {
				if (gridMainView == 'contact') {
					if (pjqABContext == 'scr' || pjqABContext == 'merge' || pjqABContext == 'pccf' || pjqABContext == 'pcf' || pjqABContext == 'deleteMultiple') {
						RemoveIfPresent(selectedContacts, rId);
					}
					else {
						var groupIds = gridMain.getUserData(rId, 'GroupIdList');
						if (groupIds)
							RemoveIfPresent(selectedGroups, gridMain.getUserData(rId, 'GroupIdList'));
						else
							RemoveIfPresent(selectedContacts, rId);
					}
				}
				else {
					if (pjqABContext == 'scr' || pjqABContext == 'merge' || pjqABContext == 'deleteMultiple' || pjqABContext == 'pccf' || pjqABContext == 'pcf') {
						RemoveIfPresent(selectedContacts, gridMain.getUserData(rId, 'SelectableContacts'));
					}
					else {
						RemoveIfPresent(selectedGroups, gridMain.getUserData(rId, 'GroupIdList'));
						if (filteredGroups.trim().length == 0 && filteredGroups.split(',').indexOf('0') == -1)
							RemoveIfPresent(selectedContacts, gridMain.getUserData(rId, 'NoGroupContactIdList'));
					}
				}

				var showPartial = false,
					data = [];

				try {
					data = gridMain.getUserData(rId, 'GroupIdList').split(',');
					for (var i = 0; i < data.length; i++) {
						if (IsInArray(parseInt(data[i]), selectedGroups))
							showPartial = true;
						else
							showPartial = IsGroupPreSelected(data[i])
					}
				} catch (err) {
				}

				if (!showPartial) {
					try {
						data = gridMain.getUserData(rId, 'NoGroupContactIdList').split(',');
						for (var i = 0; i < data.length; i++) {
							if (IsInArray(parseInt(data[i]), selectedContacts))
								showPartial = true;
							else
								showPartial = IsContactPreSelected(data[i])
						}
					} catch (err) {
					}
				}


				if (showPartial)
					gridMain.cells(rId, 0).setValue('2');
			}
		}

		if ((currentDirectoryFilter == 1 || currentDirectoryFilter == -1)) {
			if (pjqABContext == 'merge' && selectedContacts.length > 1)
				tbMain.tryEnableItem('merge');
			else if (pjqABContext == 'deleteMultiple' && selectedContacts.length > 0)
				tbMain.tryEnableItem('deleteMultiple');
		}
		else if (selectedContacts.length == 0 && (currentDirectoryFilter == 1 || currentDirectoryFilter == -1)) {
			if (pjqABContext == 'merge')
				tbMain.tryDisableItem('merge');
			else if (pjqABContext == 'deleteMultiple')
				tbMain.tryDisableItem('deleteMultiple');
		}

		var subgrid = null;
		if (gridMain.cells(rId, 1).getSubGrid)
			subgrid = gridMain.cells(rId, 1).getSubGrid();

		if (subgrid)
			SetSubGridCheck(subgrid, state);


		return true;
	});

	function gridMainXLE(id) {
		var i = 0;
		var counter = 0;


		if (gridMainView == 'company' && pjqABContext.length > 0) {
			var companyGroups = gridMain.getUserData(id, 'GroupIdList').split(',');
			if (companyGroups[0] == '')
				companyGroups = [];

			for (i = 0; i < companyGroups.length; i++) {
				if ($.inArray(parseInt(companyGroups[i]), selectedGroups) != -1)
					counter++;
			}

			var companyGroups2 = gridMain.getUserData(id, 'NoGroupContactIdList').split(',');
			if (companyGroups2[0] == '')
				companyGroups2 = [];

			for (i = 0; i < companyGroups2.length; i++) {
				if ($.inArray(parseInt(companyGroups2[i]), selectedContacts) != -1)
					counter++;
			}

			if ($.inArray(parseInt(id), selectedCompanies) != -1)
				gridMain.cells(id, 0).setChecked(true);
			else if (counter === companyGroups.length + companyGroups2.length && counter > 0)
				gridMain.cells(id, 0).setChecked(true);
			else if (counter > 0)
				gridMain.cells(id, 0).setValue('2');

		}
		if (gridMainView == 'contact' && pjqABContext.length > 0) {
			var companyGroups = gridMain.getUserData(id, 'GroupIdList').split(',');
			if (companyGroups[0] == '')
				companyGroups = [];
			for (i = 0; i < companyGroups.length; i++) {
				if ($.inArray(parseInt(companyGroups[i]), selectedGroups) != -1)
					counter++;
			}

			if ($.inArray(parseInt(id), selectedContacts) != -1)
				gridMain.cells(id, 0).setChecked(true);
			else if (counter === companyGroups.length && counter > 0)
				gridMain.cells(id, 0).setChecked(true);
			else if (counter > 0)
				gridMain.cells(id, 0).setValue('2');
		}

		if (gridMainView != 'group') {
			if (gridMain.getUserData(id, 'IsPrimaryContact') == 'true')
				jQuery(gridMain.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');
			if (gridMain.getUserData(id, 'IsBlacklisted') == 'true') {
				if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
					gridMain.cells(id, 0).setDisabled(true);
				gridMain.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
			}
			else {
				var i = 0,
					j = 0,
					k = 0,
					selectedCount = 0;
				if (gridMainView == 'company') {
					for (i = 0; i < settings.DisabledRowsCount; i++) {
						if (settings.DisabledRows[i].CC == parseInt(id)) {
							selectedCount = settings.DisabledRows[i].Cs.length;
						}
					}
					if (selectedCount > 0 && selectedCount == parseInt(gridMain.getUserData(id, "SelectableContacts").split(',').length)) {

						gridMain.cells(id, 0).setDisabled(true);

						if (selectedCount == parseInt(gridMain.getUserData(id, "ContactCount")))
							gridMain.cells(id, 0).setChecked(true);
						else
							gridMain.cells(id, 0).setChecked('2');

						var subgrid = gridMain.cells(id, 1).getSubGrid();
						if (subgrid)
							subgrid.forEachRow(function (id2) {
								for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
									if (settings.DisabledRows[i].Cs[j].Gs[k].G == subgrid.getUserData(id2, "GroupId"))
										subgrid.cells(id2, 0).setChecked(true);
								}
							});
					}
					else if (selectedCount > 0) {
						gridMain.cells(id, 0).setValue('2');
					}

				}
				else if (gridMainView == 'contact') {
					for (i = 0; i < settings.DisabledRowsCount; i++) {
						for (j = 0; j < settings.DisabledRows[i].Cs.length; j++) {
							if (settings.DisabledRows[i].Cs[j].C == parseInt(id)) {

								for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
									if (settings.DisabledRows[i].Cs[j].Gs[k].Sel || settings.DisabledRows[i].Cs[j].Gs[k].G == 0) {
										selectedCount += 1;
									}
								}
								if (selectedCount > 0 && selectedCount == settings.DisabledRows[i].Cs[j].Gs.length) {
									gridMain.cells(id, 0).setDisabled(true);
									gridMain.cells(id, 0).setChecked(true);
									var subgrid = gridMain.cells(id, 1).getSubGrid();
									if (subgrid)
										subgrid.forEachRow(function (id2) {
											for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
												if (settings.DisabledRows[i].Cs[j].Gs[k].G == subgrid.getUserData(id2, "GroupId"))
													subgrid.cells(id2, 0).setChecked(true);
											}
										});
								}
								else if (selectedCount > 0) {
									gridMain.cells(id, 0).setValue('2');
								}
							}
						}
					}
				}
			}
		}
		else {
			var unionFilter = getUnionFilter(),
				cellValue = gridMain.cells(id, 0).getValue();
			if (unionFilter.length > 0 && cellValue.toLowerCase().indexOf("getcompanies") != -1) {
				gridMain.cells(id, 0).setValue(cellValue += ("&misc=" + unionFilter));
			}
		}

		if (gridMain.getUserData(id, 'IsBlacklisted') == 'true') {
			if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge') {
				gridMain.cells(id, 0).setDisabled(true);
				gridMain.cells(id, 0).setChecked(false);
			}
			gridMain.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
		}
		else {
			var i = 0,
				j = 0,
				k = 0,
				selectedCount = 0,
				selectedCountD = 0;
			if (gridMainView == 'company') {
				var data = gridMain.getUserData(id, "SelectableContacts").split(',');
				for (i = 0; i < data.length; i++) {
					if ($.inArray(parseInt(data[i]), selectedContacts) != -1 && pjqABContext.length > 0)
						selectedCount += 1;
				}

				for (i = 0; i < settings.DisabledRowsCount; i++) {
					for (j = 0; j < settings.DisabledRows[i].length; j++) {
						if (settings.DisabledRows[i][j].C == parseInt(id))
							selectedCountD += 1;
					}
				}

				if (selectedCountD == data.length)
					gridMain.cells(id, 0).setDisabled(true);

				if (selectedCount + selectedCountD == data.length)
					gridMain.cells(id, 0).setChecked(true);
				else if (selectedCount + selectedCountD > 0) {
					gridMain.cells(id, 0).setValue('2');
				}

			}
			else if (gridMainView == 'contact') {
				for (i = 0; i < settings.DisabledRowsCount; i++) {
					for (j = 0; j < settings.DisabledRows[i].length; j++) {
						if (settings.DisabledRows[i][j].C == parseInt(id)) {

							for (k = 0; k < settings.DisabledRows[i][j].Gs.length; k++) {
								if (settings.DisabledRows[i][j].Gs[k].Sel)
									selectedCount += 1;
							}
							if (selectedCount == settings.DisabledRows[i][j].Gs.length) {
								gridMain.cells(id, 0).setDisabled(true);
								gridMain.cells(id, 0).setChecked(true);
							}
							else if (selectedCount > 0) {
								gridMain.cells(id, 0).setValue('2');
							}
						}
					}
				}
			}
		}

		if (gridMainView == 'group') {
			if (pjqABContext.length == 0) {
				tbMain.tryHideItem('cancelMerge');
				tbMain.tryHideItem('cancelMerge_sep');
				tbMain.tryHideItem('merge');
				tbMain.tryHideItem('merge_sep');
				tbMain.tryHideItem('deleteMultiple');
				tbMain.tryHideItem('deleteMultiple_sep');
				tbMain.tryHideItem('cancelDeleteMultiple');
				tbMain.tryHideItem('cancelDeleteMultiple_sep');
			}
		}
		else if (gridMainView == 'contact' || gridMainView == 'company') {
			if (pjqABContext.length == 0 && (currentDirectoryFilter == 1 || currentDirectoryFilter == -1)) {
				tbMain.tryShowItem('merge');
				tbMain.tryShowItem('merge_sep');
				tbMain.tryShowItem('deleteMultiple');
				tbMain.tryShowItem('deleteMultiple_sep');
			}
		}
		if (pjqABContext == 'merge') {
			tbSearch.tryDisableItem('directory');
			tbMain.tryDisableItem('view_group');
			tbMain.tryShowItem('cancelMerge');
			tbMain.tryShowItem('cancelMerge_sep');
			if (selectedContacts.length > 1) {
				tbMain.tryEnableItem('merge');
			}
			else {
				tbMain.tryDisableItem('merge');
			}
			jQuery('#mergeNote').remove();
			jQuery('#top-info').append("<div id='mergeNote' class='ui-state-highlight ui-corner-all' style='margin:0 10px;padding:0.7em;font-weight:bold;'>Please select two or more contacts/companies to merge.  Click \"Merge Contacts\" when you're ready to merge.</div>");
			jQuery('#top-info').removeClass('pjq-hidden');
		}
		else if (pjqABContext == 'deleteMultiple') {
			tbSearch.tryDisableItem('directory');
			tbMain.tryDisableItem('view_group');
			tbMain.tryDisableItem('merge');
			tbMain.tryShowItem('cancelDeleteMultiple');
			tbMain.tryShowItem('cancelDeleteMultiple_sep');
			if (selectedContacts.length > 0) {
				tbMain.tryEnableItem('deleteMultiple');
			}
			else {
				tbMain.tryDisableItem('deleteMultiple');
			}
			jQuery('#deleteMultipleNote').remove();
			jQuery('#top-info').append("<div id='deleteMultipleNote' class='ui-state-highlight ui-corner-all' style='margin:0 10px;padding:0.7em;font-weight:bold;'>Please select one or more contacts/companies to delete.  Click \"Delete Records\" after you've selected the contacts you would like to delete.</div>");
			jQuery('#top-info').removeClass('pjq-hidden');
		}
		else {
			tbSearch.tryEnableItem('directory');
			tbMain.tryEnableItem('view_group');
			if (pjqABContext.length == 0) {
				if (typeof tbMain.getListOptionSelected('view_approval_default') == 'undefined' || tbMain.getListOptionSelected('view_approval_default') != 'view_needs_approval') {
					tbMain.tryEnableItem('merge');
					tbMain.tryEnableItem('deleteMultiple');
				}
				else {
					tbMain.tryDisableItem('merge');
					tbMain.tryDisableItem('deleteMultiple');
				}
				tbMain.tryHideItem('cancelMerge');
				tbMain.tryHideItem('cancelMerge_sep');
				tbMain.tryHideItem('cancelDeleteMultiple');
				tbMain.tryHideItem('cancelDeleteMultiple_sep');
				jQuery('#mergeNote').remove();
				jQuery('#deleteMultipleNote').remove();
				jQuery('#top-info').addClass('pjq-hidden');
			}
		}

		if (settings.ApprovalLevelCol != null) {
			var colColor = gridMain.cells(id, settings.ApprovalLevelCol).getValue();
			if (colColor.length > 0)
				gridMain.setCellTextStyle(id, settings.ApprovalLevelCol, 'background:' + colColor);
		}
	}


	gridMain.attachEvent("onSubGridCreated", function (sub_grid_obj, rId, rInd) {
		sub_grid_obj.enableAutoHeight(true);
		sub_grid_obj.enableMultiline(true);
		sub_grid_obj.attachEvent("onXLS", function (grid_obj) {
			ShowBusy("Loading...");
		});
		sub_grid_obj.attachEvent("onXLE", function (grid_obj) {
			HideBusy();

			sub_grid_obj.forEachRow(subGridXLE);

		});

		sub_grid_obj.attachEvent("onRowDblClicked", function (id, ind) {
			var contactId = 0;
			if (gridMainView == 'group') {
				contactId = sub_grid_obj.getSelectedRowId();
			}
			else if (gridMainView == 'company') {
				contactId = sub_grid_obj.getSelectedRowId();
			}
			else if (gridMainView == 'contact') {
				contactId = sub_grid_obj.getUserData(id, 'ContactId');
			}

			if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove))
				return;

			getContactInfo(parseInt(contactId));
		});

		sub_grid_obj.enableContextMenu(cmCompany);

		sub_grid_obj.attachEvent("onBeforeContextMenu", function (id, ind, obj) {

			lastContactId = id;
			if (gridMainView == 'contact')
				lastContactIdView = 'group';
			else if (gridMainView == 'company')
				lastContactIdView = 'contact';
			else if (gridMainView == 'group')
				lastContactIdView = 'company';

			gridMain.selectRowById(rId);
			obj.selectRowById(id);
			cmCompany.hideContextMenu();
			cmContact.hideContextMenu();
			var isDirectoryContact = (sub_grid_obj.getUserData(id, "IsDirectoryContact") == 'true');
			if (gridMainView == 'group') {
				if (isDirectoryContact || currentDirectoryFilter == 2)
					cmCompany.showItem('copyDirectory');
				else
					cmCompany.hideItem('copyDirectory');
				if ((isDirectoryContact || currentDirectoryFilter == 2) || settings.IsEnableReportPrivateContact)
					cmCompany.showItem('report');
				else
					cmCompany.hideItem('report');

				if (isDirectoryContact)
					cmCompany.hideItem('delete');

				sub_grid_obj.enableContextMenu(cmCompany);
			}
			else if (gridMainView == 'company') {
				sub_grid_obj.enableContextMenu(cmContact);

				if (sub_grid_obj.getUserData(id, 'IsPrimaryContact') == 'true') {
					if (!settings.IsRO && !settings.IsDD)
						cmContact.hideItem('delete');
				}
				else {
					if (!settings.IsRO && !settings.IsDD)
						cmContact.showItem('delete');
				}

				if (isDirectoryContact || currentDirectoryFilter == 2)
					cmContact.showItem('copyDirectory');
				else
					cmContact.hideItem('copyDirectory');
				if ((isDirectoryContact || currentDirectoryFilter == 2) || settings.IsEnableReportPrivateContact)
					cmContact.showItem('report');
				else
					cmContact.hideItem('report');

				if (isDirectoryContact)
					cmContact.hideItem('delete');
			}

			if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove)) {
				cmContact.hideItem('edit');
				cmContact.hideItem('delete');
			}
			else {
				cmContact.showItem('edit');

				if (!settings.IsRO && !settings.IsDD && !isDirectoryContact)
					cmContact.showItem('delete');
			}

			if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (settings.IsApprovalEditEnabled || settings.CanApprove))
				cmContact.showItem('approve');
			else if (settings.IsApprovalRequired)
				cmContact.hideItem('approve');

			if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove)) {
				cmCompany.hideItem('edit');
				cmCompany.hideItem('delete');
			}
			else {
				cmCompany.showItem('edit');

				if (!settings.IsRO && !settings.IsDD && !isDirectoryContact)
					cmCompany.showItem('delete');
			}

			return true;
		});

		sub_grid_obj.attachEvent("onRowSelect", function (id, ind) {
			gridMain.setSelectedRow(rId);
			if (gridMainView == 'company' || gridMainView == 'group')
				lastContactId = id;

			gridMain.forEachRow(function (id2) {
				var subgrid;
				var index = 0;
				if (gridMainView != 'group')
					index += 1;
				if (settings.AddressBookContext != '')
					index += 1;

				if (gridMain.cells(id2, index).getSubGrid)
					subgrid = gridMain.cells(id2, index).getSubGrid();

				if (subgrid) {
					subgrid.clearSelection();
				}
			});

			sub_grid_obj.setSelectedRow(id);

			if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
				if (settings.IsApprovalEditEnabled || settings.CanApprove)
					tbMain.tryEnableItem('edit');
				else
					tbMain.tryDisableItem('edit');
			}
			else
				tbMain.tryEnableItem('edit');

			if (sub_grid_obj.getColLabel(ind).toLowerCase().indexOf('email') > -1) {
				if (sub_grid_obj.cell.innerText && sub_grid_obj.cell.innerText.length > 0) {
					window.location.href = 'mailto:' + sub_grid_obj.cell.innerText;
				}
			}

		});


		sub_grid_obj.attachEvent("onSubGridCreated", function (sub_grid_obj2, rId2, rInd2) {
			if (gridMainView == 'group')
				sub_grid_obj2.enableContextMenu(cmContact);

			sub_grid_obj2.attachEvent("onRowDblClicked", function (id, ind) {
				var contactId = 0;
				if (gridMainView == 'group') {
					contactId = sub_grid_obj2.getUserData(id, 'ContactId');
				}
				else if (gridMainView == 'company') {
					contactId = sub_grid_obj2.getUserData(id, 'ContactId');
				}

				if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove))
					return;

				getContactInfo(parseInt(contactId));
			});


			sub_grid_obj2.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
				lastContactId = id;
				if (gridMainView == 'group')
					lastContactId = sub_grid_obj2.getUserData(id, 'ContactId');

				if (gridMainView == 'company')
					lastContactIdView = 'group';
				else if (gridMainView == 'group')
					lastContactIdView = 'contact';

				obj.selectRowById(id);
				cmCompany.hideContextMenu();
				cmContact.hideContextMenu();
				var isDirectoryContact = (sub_grid_obj2.getUserData(id, "IsDirectoryContact") == 'true');
				if (gridMainView == 'group') {
					sub_grid_obj2.enableContextMenu(cmContact);

					if (sub_grid_obj2.getUserData(id, 'IsPrimaryContact') == 'true') {
						if (!settings.IsRO && !settings.IsDD)
							cmContact.hideItem('delete');
					}
					else {
						if (!settings.IsRO && !settings.IsDD)
							cmContact.showItem('delete');
					}

					if (isDirectoryContact || currentDirectoryFilter == 2)
						cmContact.showItem('copyDirectory');
					else
						cmContact.hideItem('copyDirectory');
					if ((isDirectoryContact || currentDirectoryFilter == 2) || settings.IsEnableReportPrivateContact)
						cmContact.showItem('report');
					else
						cmContact.hideItem('report');

					if (isDirectoryContact)
						cmContact.hideItem('delete');

				}

				if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove)) {
					cmContact.hideItem('edit');
					cmContact.hideItem('delete');
				}
				else {
					cmContact.showItem('edit');

					if (!settings.IsRO && !settings.IsDD && !isDirectoryContact)
						cmContact.showItem('delete');
				}

				if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (settings.IsApprovalEditEnabled || settings.CanApprove))
					cmContact.showItem('approve');
				else if (settings.IsApprovalRequired)
					cmContact.hideItem('approve');

				if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && (!settings.IsApprovalEditEnabled || !settings.CanApprove)) {
					cmCompany.hideItem('edit');
					cmCompany.hideItem('delete');
				}
				else {
					cmCompany.showItem('edit');

					if (!settings.IsRO && !settings.IsDD && !isDirectoryContact)
						cmCompany.showItem('delete');
				}

				return true;
			});

			sub_grid_obj2.attachEvent("onRowSelect", function (id, ind) {
				sub_grid_obj.setSelectedRow(rId2);
				gridMain.setSelectedRow(rId);
				if (gridMainView == 'group') {
					lastContactId = sub_grid_obj2.getUserData(id, 'ContactId');

					if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
						if (settings.IsApprovalEditEnabled || settings.CanApprove)
							tbMain.tryEnableItem('edit');
						else
							tbMain.tryDisableItem('edit');
					}
					else
						tbMain.tryEnableItem('edit');

				}
				else if (gridMainView != 'company') {
					lastContactId = id;

					if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
						if (settings.IsApprovalEditEnabled || settings.CanApprove)
							tbMain.tryEnableItem('edit');
						else
							tbMain.tryDisableItem('edit');
					}
					else
						tbMain.tryEnableItem('edit');
				}

				if (sub_grid_obj2.getColLabel(ind).toLowerCase().indexOf('email') > -1) {
					if (sub_grid_obj2.cell.innerText && sub_grid_obj2.cell.innerText.length > 0) {
						window.location.href = 'mailto:' + sub_grid_obj2.cell.innerText;
					}
				}

			});

			sub_grid_obj2.enableAutoHeight(true);
			sub_grid_obj2.enableMultiline(true);
			sub_grid_obj2.attachEvent("onXLS", function (grid_obj) {
				ShowBusy("Loading...");
			});
			sub_grid_obj2.attachEvent("onXLE", function (grid_obj) {
				HideBusy();
				sub_grid_obj2.forEachRow(function (id) {
					var i = 0,
						j = 0,
						k = 0,
						selectedCount = 0;
					if (gridMainView == 'group') {
						for (i = 0; i < settings.DisabledRowsCount; i++) {
							for (j = 0; j < settings.DisabledRows[i].Cs.length; j++) {

								for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
									if ((settings.DisabledRows[i].Cs[j].Gs[k].CG == parseInt(id) && settings.DisabledRows[i].Cs[j].Gs[k].Sel) || (settings.DisabledRows[i].Cs[j].Gs[k].G == 0 && sub_grid_obj2.getUserData(id, 'ContactId') == settings.DisabledRows[i].Cs[j].C)) {
										sub_grid_obj2.cells(id, 0).setDisabled(true);
										sub_grid_obj2.cells(id, 0).setChecked(true);
									}
								}
							}

						}

					}
					else if (gridMainView == 'company') {
						for (i = 0; i < settings.DisabledRowsCount; i++) {
							for (j = 0; j < settings.DisabledRows[i].Cs.length; j++) {
								if (sub_grid_obj2.getUserData(id, 'ContactId') == settings.DisabledRows[i].Cs[j].C) {
									for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
										if ((settings.DisabledRows[i].Cs[j].Gs[k].Sel && settings.DisabledRows[i].Cs[j].Gs[k].CG == parseInt(id) && !id.endsWith('_0')) || (settings.DisabledRows[i].Cs[j].Gs[k].G == 0)) {
											sub_grid_obj2.cells(id, 0).setDisabled(true);
											sub_grid_obj2.cells(id, 0).setChecked(true);
										}
									}
								}
							}
						}
					}

					if (gridMainView == 'group' && IsInArray(parseInt(id), selectedContacts) || IsInArray(parseInt(id), selectedGroups) && pjqABContext.length > 0)
						sub_grid_obj2.cells(id, 0).setChecked(true);
					else if ((gridMainView == 'company' || gridMainView == 'contact') && IsInArray(parseInt(id), selectedGroups) && pjqABContext.length > 0)
						sub_grid_obj2.cells(id, 0).setChecked(true);

					if (sub_grid_obj2.getUserData(id, 'IsPrimaryContact') == 'true')
						jQuery(sub_grid_obj2.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');
					if (sub_grid_obj2.getUserData(id, 'IsBlacklisted') == 'true') {
						if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
							sub_grid_obj2.cells(id, 0).setDisabled(true);
						sub_grid_obj2.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
					}
					if (sub_grid_obj.getUserData(rId2, 'IsBlacklisted') == 'true') {
						if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
							sub_grid_obj2.cells(id, 0).setDisabled(true);
						sub_grid_obj2.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
					}

				});
			});

			return true;
		});

		return true;
	});

	gridMain.attachEvent("onSubRowOpen", function (sub_grid_obj, rId, rInd) {
		gridMain.setSizes();
	});

	gridMain.attachEvent("onSubGridLoaded", function (sub_grid_obj, rId, rInd) {
		if (pjqABContext.length > 0)
			jQuery('div.xhdr table.hdr td:nth-child(1)').addClass('centerme');

		sub_grid_obj.attachEvent("onCheck", function (rId2, cInd2, state) {

			if (gridMainView != 'group') {

				var checkedCount = 0,
					partCheckedCount = 0;
				sub_grid_obj.forEachRow(function (id) {
					if (sub_grid_obj.cells(id, 0).getValue() == '1')
						checkedCount++;
					if (sub_grid_obj.cells(id, 0).getValue() == '2')
						partCheckedCount++;
				});

				if (checkedCount + partCheckedCount == 0) {
					gridMain.cells(rId, 0).setValue('0');
				}
				else if (checkedCount == sub_grid_obj.getRowsNum()) {
					gridMain.cells(rId, 0).setValue('1');
				}
				else {
					gridMain.cells(rId, 0).setValue('2');
				}
			}

			var i, index = -1;
			if (gridMainView == 'group') {
				if (state) {
					if (pjqABContext == 'pcf' || pjqABContext == 'pccf') {
						AddIfMissing(selectedContacts, sub_grid_obj.getUserData(rId2, 'SelectableContacts'));
					}
					else if (pjqABContext != 'scr' && pjqABContext != 'merge' && pjqABContext != 'deleteMultiple' && pjqABContext != 'ap2' && pjqABContext != 'ap3')
						AddIfMissing(selectedContacts, rId2);
					else {
						AddIfMissing(selectedGroups, sub_grid_obj.getUserData(rId2, 'GroupIdList'));
						AddIfMissing(selectedContacts, sub_grid_obj.getUserData(rId2, 'NoGroupContactIdList'));
					}
				}
				else {
					jQuery('#check-all-groups').prop('checked', false);
					if (pjqABContext == 'pcf' || pjqABContext == 'pccf') {
						RemoveIfPresent(selectedContacts, sub_grid_obj.getUserData(rId2, 'SelectableContacts'));
					}
					else if (pjqABContext != 'scr' && pjqABContext != 'merge' && pjqABContext != 'deleteMultiple' && pjqABContext != 'ap2' && pjqABContext != 'ap3')
						RemoveIfPresent(selectedContacts, rId2);
					else {
						RemoveIfPresent(selectedGroups, sub_grid_obj.getUserData(rId2, 'GroupIdList'));
						RemoveIfPresent(selectedContacts, sub_grid_obj.getUserData(rId2, 'NoGroupContactIdList'));
					}
				}
			}
			else if (gridMainView == 'company') {
				if (pjqABContext != 'scr' && pjqABContext != 'merge' && pjqABContext != 'pccf' && pjqABContext != 'pcf' && pjqABContext != 'deleteMultiple' && sub_grid_obj.getUserData(rId2, 'GroupIdList') && sub_grid_obj.getUserData(rId2, 'GroupIdList').length > 0) {
					if (state)
						AddIfMissing(selectedGroups, sub_grid_obj.getUserData(rId2, 'GroupIdList'));
					else
						RemoveIfPresent(selectedGroups, sub_grid_obj.getUserData(rId2, 'GroupIdList'));
				}
				else {
					if (state)
						AddIfMissing(selectedContacts, rId2);
					else
						RemoveIfPresent(selectedContacts, rId2);
				}
			}
			else if (gridMainView == 'contact') {
				if (rId2.endsWith('_0')) {
					if (state)
						AddIfMissing(selectedContacts, rId2);
					else
						RemoveIfPresent(selectedContacts, rId2);
				}
				else {
					if (state)
						AddIfMissing(selectedGroups, rId2);
					else
						RemoveIfPresent(selectedGroups, rId2);
				}
			}

			if (sub_grid_obj.cells(rId2, 1) && sub_grid_obj.cells(rId2, 1).getSubGrid) {
				var subgrid = sub_grid_obj.cells(rId2, 1).getSubGrid();

				if (subgrid)
					SetSubGridCheck(subgrid, state);
			}

			if (!state) {

				var showPartial = false,
					data = [];
				try {
					data = sub_grid_obj.getUserData(rId2, 'GroupIdList').split(',');
					for (var i = 0; i < data.length; i++) {
						if (IsInArray(parseInt(data[i]), selectedGroups))
							showPartial = true;
						else
							showPartial = IsGroupPreSelected(data[i])
					}
				} catch (err) {
				}

				if (!showPartial) {
					try {
						data = sub_grid_obj.getUserData(rId2, 'NoGroupContactIdList').split(',');
						for (var i = 0; i < data.length; i++) {
							if (IsInArray(parseInt(data[i]), selectedContacts))
								showPartial = true;
							else
								showPartial = IsContactPreSelected(data[i])
						}
					} catch (err) {
					}
				}


				if (showPartial)
					sub_grid_obj.cells(rId2, 0).setValue('2');
			}

			return true;
		});

		setTimeout(function () {
			sub_grid_obj.setSizes();
			sub_grid_obj.callEvent("onGridReconstructed", []);
			gridMain.setSizes();
		}, 100);

		sub_grid_obj.forEachRow(subGridXLE);

		sub_grid_obj.attachEvent("onSubRowOpen", function (sub_grid_obj, rId, rInd) {
			gridMain.setSizes();
		});

		sub_grid_obj.attachEvent("onSubGridLoaded", function (sub_grid_obj2, rId2, rInd2) {
			if (pjqABContext.length > 0)
				jQuery('div.xhdr table.hdr td:nth-child(1)').addClass('centerme');

			sub_grid_obj2.attachEvent("onCheck", function (rId3, cInd3, state3) {
				var checkedCount = 0,
					partCheckedCount = 0;
				sub_grid_obj2.forEachRow(function (id) {
					if (sub_grid_obj2.cells(id, 0).getValue() == '1')
						checkedCount++;
					else if (sub_grid_obj2.cells(id, 0).getValue() == '2')
						partCheckedCount++;
				});

				if (checkedCount + partCheckedCount == 0) {
					sub_grid_obj.cells(rId2, 0).setValue('0');
				}
				else if (checkedCount == sub_grid_obj2.getRowsNum()) {
					sub_grid_obj.cells(rId2, 0).setValue('1');
				}
				else {
					sub_grid_obj.cells(rId2, 0).setValue('2');
				}

				if (gridMainView != 'group') {
					checkedCount = 0;
					var partCheckedCount = 0;
					sub_grid_obj.forEachRow(function (id) {
						if (sub_grid_obj.cells(id, 0).getValue() == '1')
							checkedCount++;
						else if (sub_grid_obj.cells(id, 0).getValue() == '2')
							partCheckedCount++;
					});

					if (checkedCount + partCheckedCount == 0) {
						gridMain.cells(rId, 0).setValue('0');
					}
					else if (checkedCount == sub_grid_obj.getRowsNum()) {
						gridMain.cells(rId, 0).setValue('1');
					}
					else {
						gridMain.cells(rId, 0).setValue('2');
					}

				}

				var i, index = -1;
				if (gridMainView == 'group') {

					if (!rId3.endsWith('_0')) {
						if (state3) {
							if (pjqABContext == 'pccf' || pjqABContext == 'pcf' || sub_grid_obj2.getUserData(rId3, "GroupIdList") == '')
								AddIfMissing(selectedContacts, sub_grid_obj2.getUserData(rId3, 'ContactId'));
							else if (pjqABContext == 'scr' || sub_grid_obj2.getUserData(rId3, "GroupIdList") == '')
								AddIfMissing(selectedContacts, rId3.indexOf('_') > -1 ? rId3.split('_')[0] : rId3);
							else
								AddIfMissing(selectedGroups, sub_grid_obj2.getUserData(rId3, "GroupIdList"));
						}
						else {
							jQuery('#check-all-groups').prop('checked', false);
							if (pjqABContext == 'pccf' || pjqABContext == 'pcf' || sub_grid_obj2.getUserData(rId3, "GroupIdList") == '')
								RemoveIfPresent(selectedContacts, sub_grid_obj2.getUserData(rId3, 'ContactId'));
							else if (pjqABContext == 'scr' || sub_grid_obj2.getUserData(rId3, "GroupIdList") == '')
								RemoveIfPresent(selectedContacts, rId3.indexOf('_') > -1 ? rId3.split('_')[0] : rId3);
							else
								RemoveIfPresent(selectedGroups, sub_grid_obj2.getUserData(rId3, "GroupIdList"));
						}
					}
					else {
						if (state3)
							AddIfMissing(selectedContacts, rId3.indexOf('_') > -1 ? rId3.split('_')[0] : rId3);
						else {
							RemoveIfPresent(selectedContacts, rId3.indexOf('_') > -1 ? rId3.split('_')[0] : rId3);
							jQuery('#check-all-groups').prop('checked', false);
						}
					}
				}
				else if (gridMainView == 'company') {
					if (rId3.endsWith('_0')) {
						if (state3)
							AddIfMissing(selectedContacts, rId3);
						else
							RemoveIfPresent(selectedContacts, rId3);
					}
					else {
						if (state3)
							AddIfMissing(selectedGroups, rId3.indexOf('_') > -1 ? rId3.split('_')[1] : rId3);
						else
							RemoveIfPresent(selectedGroups, rId3.indexOf('_') > -1 ? rId3.split('_')[1] : rId3);
					}
				}
			});


			sub_grid_obj2.setSizes();
			sub_grid_obj2.callEvent("onGridReconstructed", []);
			sub_grid_obj.setSizes();
			gridMain.setSizes();

			sub_grid_obj2.forEachRow(function (id) {
				if (gridMainView == 'group' && IsInArray(parseInt(id), selectedContacts) || IsInArray(parseInt(id), selectedGroups) && pjqABContext.length > 0)
					sub_grid_obj2.cells(id, 0).setChecked(true);
				else if ((gridMainView == 'company' || gridMainView == 'contact') && IsInArray(parseInt(id), selectedGroups) && pjqABContext.length > 0)
					sub_grid_obj2.cells(id, 0).setChecked(true);

				if (sub_grid_obj2.getUserData(id, 'IsPrimaryContact') == 'true')
					jQuery(sub_grid_obj2.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');
				if (sub_grid_obj2.getUserData(id, 'IsBlacklisted') == 'true') {
					if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
						sub_grid_obj2.cells(id, 0).setDisabled(true);
					sub_grid_obj2.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
				}
				if (sub_grid_obj.getUserData(rId2, 'IsBlacklisted') == 'true') {
					if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
						sub_grid_obj2.cells(id, 0).setDisabled(true);
					sub_grid_obj2.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
				}

			});
		});

		return true;
	});

	gridMain.attachEvent("onBeforeSorting", function (ind, type, direction) {

		gridMain.setSortImgState(true, ind, direction);
		if (type == 'server') {
			if (view == 'contact' && settings.AddressBookContext.length > 0)
				ind -= 2;
			else if (view == 'company' && settings.AddressBookContext.length > 0)
				ind -= 1;
			gridMain.clearAll(true);
			var parts;
			if (view == 'company') {
				parts = pjqABFMCompany;
				parts = parts.split(',');
				parts = parts[ind - 1].split('|')[0];
			}
			else if (view == 'contact') {
				parts = pjqABFMContact;
				parts = parts.split(',');
				parts = parts[ind].split('|')[0];
			}
			else if (view == 'group') {
				parts = pjqABFMGroup;
				parts = parts.split(',');
				parts = parts[ind - 1].split('|')[0];
			}
			if (view == 'contact' && settings.AddressBookContext.length > 0)
				ind += 2;
			else if (view == 'company' && settings.AddressBookContext.length > 0)
				ind += 1;

			gridMainSortIndex = ind;
			gridMainSortOrder = parts;


			gridMainSortDirection = direction;
			SetABSPc();
		}
		return true;
	});

	if (view == 'company') {
		gridMainSortOrder = 'CompanyName';
		gridMainSortDirection = 'asc';
	}
	else if (view == 'contact') {
		gridMainSortOrder = 'CompanyName';
		gridMainSortDirection = 'asc';
		if (gridMainSortOrder.startsWith('Default')) {
			gridMainSortOrder = gridMainSortOrder.replace('Default', '');
			gridMainSortDirection = 'asc';
		}
	}
	else if (view == 'group') {
		gridMainSortOrder = 'SortOrder';
		gridMainSortDirection = 'asc';
	}

	var searchFor = tbSearch.getValue('search_for');
	if (searchFor.length <= 15 && DigitsOnly(searchFor).length == 10)
		searchFor = DigitsOnly(searchFor);

	if (searchFor.length == 0 && tbLocation.getValue('zip').length == 0 && filteredGroups.length == 0 && !isAdvSearch)
		isBlankSearch = true;
	else
		isBlankSearch = false;

	if (!isAdvSearch) {
		var radius = tbLocation.getListOptionSelected('radius');
		radius = radius.substring(radius.indexOf('_') + 1);
		PanteraScript.PanteraScriptService.SetAddressBookSearchParameters(pjqSessionId, view, searchFor, currentLocationFilter, tbLocation.getValue('zip'), parseInt(radius), filteredGroups, currentDirectoryFilter, getContactTypeFilter(), getUnionFilter(), SetABSPc, onScriptError);
	}
	else
		SetABSPc();
}

function DigitsOnly(input) {
	var result = '';
	var i = 0;
	for (i = 0; i < input.length; i++) {
		result += jQuery.isNumeric(input[i]) ? input[i] : '';
	}

	return result;
}

function SetABSPc() {
	var xmlFile = '';

	if (gridMainView == 'company') {
		xmlFile = '/DesktopModules/PJQAddressBook/GetCompanies' + '.aspx?view=company&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
	}
	else if (gridMainView == 'contact') {

		xmlFile = '/DesktopModules/PJQAddressBook/GetContacts' + '.aspx?view=contact&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
	}
	else if (gridMainView == 'group') {
		xmlFile = '/DesktopModules/PJQAddressBook/GetGroups' + '.aspx?view=groups&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + ' &x=' + (new Date).getTime();
	}

	if (settings.IsDirectory) {
		CheckDirectorySearch();
		xmlFile += ('&dir=' + currentDirectoryFilter);
	}

	var unionFilter = getUnionFilter(),
		contactTypeFilter = getContactTypeFilter();
	if (unionFilter.length > 0) {
		xmlFile += '&misc=' + unionFilter;
	}
	if (contactTypeFilter.length > 0) {
		xmlFile += '&ctf=' + contactTypeFilter;
	}

	if (pjqABContext == 'scr')
		xmlFile += '&scr=1';

	var screeningFilter = '';
	if (lastFilter == 'filter-pending')
		screeningFilter = 'PENDING';
	else if (lastFilter == 'filter-inprocess')
		screeningFilter = 'INPROCESS';
	else if (lastFilter == 'filter-allclear')
		screeningFilter = 'APPROVED';
	else if (lastFilter == 'filter-review')
		screeningFilter = 'REVIEW';
	else if (lastFilter == 'filter-grade')
		screeningFilter = 'FEEDBACK';
	else if (lastFilter == 'filter-processed')
		screeningFilter = 'ENROLLED';
	else if (lastFilter == 'filter-expired')
		screeningFilter = 'EXPIRED';

	if (screeningFilter.length > 0)
		xmlFile += '&sflt=' + screeningFilter;

	if (pjqABContext.length > 0)
		xmlFile += '&cb=1';

	if (isAdvSearch) {
		if (advSearch && advSearch.AddressBookSearchId != '00000000-0000-0000-0000-000000000000')
			xmlFile += '&adv=' + advSearch.AddressBookSearchId;
		else if (advSearch && advSearch.AddressBookSearchTempId != '00000000-0000-0000-0000-000000000000')
			xmlFile += '&advt=' + advSearch.AddressBookSearchTempId;

	}

	if (settings.IsApprovalRequired) {
		if (tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
			xmlFile += '&sflt=SELFADD_APPROVAL_NEEDED';
			tbMain.tryDisableItem('merge');
			tbMain.tryDisableItem('deleteMultiple');
		}
		else {
			if (tbMain.getType('merge') != null)
				tbMain.tryEnableItem('merge');

			if (tbMain.getType('deleteMultiple') != null)
				tbMain.tryEnableItem('deleteMultiple');
		}
	}

	if (!isBlankSearch || (!settings.IsHideDefaultSearch && isBlankSearch) || tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
		jQuery('#grid-main').show();
		jQuery('#grid-main-paging').show();
		jQuery('#grid-main-paging2').show();
		gridMain.loadXML(xmlFile, function () {
			if (pjqABContext.length > 0)
				jQuery('div.xhdr table.hdr td:nth-child(1)').addClass('centerme');

			tbMain.tryDisableItem('edit');

			if (gridMainView != 'group') {
				gridMain.forEachRow(function (id) {
					if (gridMain.getUserData(id, 'IsPrimaryContact') == 'true')
						jQuery(gridMain.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');
					if (gridMain.getUserData(id, 'IsBlacklisted') == 'true') {
						if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
							gridMain.cells(id, 0).setDisabled(true);
						gridMain.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
					}
					if (gridMain.getUserData(id, 'SelectableContacts') == '' && gridMainView == 'company') {
						gridMain.cells(id, 0).setDisabled(true);
					}
				});
			}

			gridMain.setSortImgState(true, gridMainSortIndex, gridMainSortDirection);

			if (gridMainLastPage > 1) {
				gridMain.changePageRelative(gridMainLastPage - 1);
				gridMainLastPage = 0;
			}
			else if (gridMainLastPage == 1) {
				if (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval') {
					if (settings.IsApprovalEditEnabled || settings.CanApprove)
						tbMain.tryEnableItem('edit');
					else
						tbMain.tryDisableItem('edit');
				}
				else
					tbMain.tryEnableItem('edit');

				gridMainLastPage = 0;
			}

			setTimeout(GridResized, 500);
		});
	}
	else {
		jQuery('#grid-main').hide();
		jQuery('#grid-main-paging').hide();
		jQuery('#grid-main-paging2').hide();
		HideBusy();
	}
}


function ShowBusy(message) {
	EnableToolbars(false);
	jQuery('#pjq-busy').html("<img src='/i/ajax-loader.gif' alt='Busy...' style='vertical-align: middle;' /><span style='font-weight: bold;vertical-align: middle; padding-left: 6px;'>" + message + "</span>");
	jQuery("#pjq-busy").removeClass('pjq-hidden');
}

function HideBusy() {
	EnableToolbars(true);
	jQuery("#pjq-busy").addClass('pjq-hidden');
}

function KeepAlive() {
	clearTimeout(pjqKeepAlive);
	jQuery.get('/DesktopModules/PanteraModuleGlobal/KeepAlive.aspx');
	pjqKeepAlive = setTimeout(KeepAlive, 300000);
}

function showInfoDialogAB(titleText, message, iconClass, context) {
	if (iconClass)
		jQuery('#dialog-message-icon').addClass(iconClass);
	else
		jQuery('#dialog-message-icon').addClass('ui-icon-info');

	jQuery('#dialog-message-context').val(context);

	jQuery('#dlg-message-span').html(message);
	var buttonList = {
		Ok: function () {
			$(this).dialog("close");
			if (context == 'new-screening-sent') {
				InitializeGridMain(gridMainView);
			}
		}
	};

	if (context == 'no-buttons') {
		buttonList = {};
	}
	else if (context == 'delete-contact' || context == 'delete-adv-search' || context == 'delete-company-doc' || context == 'contact-updater' || context == 'main-view' || context == 'add-contacts' || context == 'approve-contact' || context == 'delete-contacts-multiple' || context == 'report-contact' || 'request-prequal' || context == 'screening-comment-delete' || context == 'screening-send-confirm' || context == 'duplicate-contact' || context == 'delete-contact-regions' || context == 'approve-change-list' || context == 'copy-change-list' || context == 'mirror-groups') {
		buttonList = {
			Ok: function () {
				if (context == 'add-contacts') {
					AddSelectedContacts();
				}
				else if (context == 'approve-contact') {
					if (typeof ApproveContact == 'function')
						ApproveContact();
				}
				else if (context == 'delete-contact') {
					if (typeof DeleteContact == 'function')
						DeleteContact();
				}
				else if (context == 'delete-adv-search') {
					PanteraScript.PanteraScriptService.DeleteAdvancedSearchAB(pjqSessionId, advSearch.AddressBookSearchId, DeleteAdvSearchC, onScriptError);
				}
				else if (context == 'delete-company-doc') {
					DeleteCompanyDocC();
				}
				else if (context == 'contact-updater') {
					SendContactUpdater();
				}
				else if (context == 'main-view') {
					InitializeGrid();
				}
				else if (context == 'report-contact') {
					InitializeGridMain(gridMainView);
				}
				else if (context == 'request-prequal') {
					RequestContactPrequalification();
				}
				else if (context == 'delete-contacts-multiple') {
					DeleteSelectedContacts();
					ShowBusy('Deleting Contacts...');
				}
				else if (context == 'screening-send-confirm') {
					SendScreening();
				}
				else if (context == 'screening-comment-delete') {
					ScreeningCommentDelete();
				}
				else if (context == 'duplicate-contact') {
					SaveEditContact2();
				}
				else if (context == 'delete-contact-regions') {
					window.regionsMapObj.DeleteAllRegions();
				}
				else if (context == 'approve-change-list') {
					applyApproveChanges2();
				}
				else if (context == 'copy-change-list') {
					copyApproveChanges2();
				}
				else if (context == 'mirror-groups') {
					mirrorGroups();
				}

				$(this).dialog("close");
			},
			Cancel: function () {
				$(this).dialog("close");
			}
		};

		if (context == 'duplicate-contact') {
			buttonList["Go to Existing"] = function () {
				getContactInfo(duplicateContactId);
				$(this).dialog("close");
			}
		}

	}
	var dialog = jQuery("#dialog-message");
	dialog.dialog({
		modal: true,
		title: titleText,
		buttons: buttonList
	});
	return dialog;
}


function str_ci(a, b, order) {
	if (order == "asc")
		return (a.toLowerCase() > b.toLowerCase() ? 1 : -1);
	else
		return (a.toLowerCase() > b.toLowerCase() ? -1 : 1);
}

function eXcell_ch3(a) {
	if (a) this.cell = a, this.grid = this.cell.parentNode.grid;
	this.disabledF = function (a) {
		this.cell.innerHTML = a == !0 || a == 1 ? this.cell.innerHTML.replace("item_chk0a.", "item_chk0a_dis.").replace("item_chk1a.", "item_chk1a_dis.") : this.cell.innerHTML.replace("item_chk0a_dis.", "item_chk0a.").replace("item_chk1a_dis.", "item_chk1a.")
	};
	this.changeState = function (a) {
		a === !0 && !this.grid.isActive && (window.globalActiveDHTMLGridObject != null && window.globalActiveDHTMLGridObject != this.grid && window.globalActiveDHTMLGridObject.isActive && window.globalActiveDHTMLGridObject.setActive(!1), this.grid.setActive(!0));
		if (this.grid.isEditable && !this.cell.parentNode._locked && !this.isDisabled())
			(true) ?
				(
					this.val = this.getValue(),
						this.val == "1" ? (this.setValue("0")) : ((this.val == "0" || this.val == "2") ? this.setValue("1") : this.setValue("0")),
						this.cell.wasChanged = !0,
						this.grid.callEvent("onCheckbox", [this.cell.parentNode.idd, this.cell._cellIndex, this.val != "1"]),
						this.grid.callEvent("onCheck", [this.cell.parentNode.idd, this.cell._cellIndex, this.val != "1"])
				) : this.editor = null
	};
	this.getValue = function () {
		return this.cell.chstate ? this.cell.chstate.toString() : "0"
	};
	this.isCheckbox = function () {
		return !0
	};
	this.isChecked = function () {
		return this.getValue() == "1" ? !0 : !1
	};
	this.setChecked = function (a) {
		this.setValue(a.toString())
	};
	this.detach = function () {
		return this.val != this.getValue()
	};
	this.edit = null
}

eXcell_ch3.prototype = new eXcell;
eXcell_ch3.prototype.setValue = function (a) {
	this.cell.style.verticalAlign = "middle";
	if (a && (a = a.toString()._dhx_trim(), a == "false" || a == "0")) a = "0";
	if (a == 'true' || a == '1') {
		a = "1";
		this.cell.chstate = "1";
		var subgrid = this.grid.cells(this.cell.parentNode.idd, 0).getSubGrid ? this.grid.cells(this.cell.parentNode.idd, 0).getSubGrid() : null;
		if (subgrid == null)
			subgrid = this.grid.cells(this.cell.parentNode.idd, 1).getSubGrid ? this.grid.cells(this.cell.parentNode.idd, 1).getSubGrid() : null;
		if (subgrid != null) {
			subgrid.forEachRow(function (id) {
				if (subgrid.cells(id, 0).isCheckbox() && (pjqABContext == 'deleteMultiple' || (subgrid.getUserData(id, "IsBlacklisted") != 'true' && subgrid.getUserData(id, "IsAutoSelectDisabled") != 'true')) && !subgrid.cells(id, 0).isDisabled()) {
					subgrid.cells(id, 0).setChecked(true);

					var subgrid2 = subgrid.cells(id, 0).getSubGrid ? this.grid.cells(id, 0).getSubGrid() : null;
					if (subgrid2 == null)
						subgrid2 = subgrid.cells(id, 1).getSubGrid ? subgrid.cells(id, 1).getSubGrid() : null;
					if (subgrid2 != null)
						subgrid2.forEachRow(function (id2) {
							if (subgrid2.cells(id2, 0).isCheckbox() && (pjqABContext == 'deleteMultiple' || (subgrid2.getUserData(id2, "IsBlacklisted") != 'true' && subgrid2.getUserData(id2, "IsAutoSelectDisabled") != 'true')) && !subgrid2.cells(id2, 0).isDisabled())
								subgrid2.cells(id2, 0).setChecked(true);
						});
				}
			});

		}
	}
	else if (a == null || a == 'false' || a == '0') {
		a = "0";
		this.cell.chstate = "0";
		var subgrid = this.grid.cells(this.cell.parentNode.idd, 0).getSubGrid ? this.grid.cells(this.cell.parentNode.idd, 0).getSubGrid() : null;
		if (subgrid == null)
			subgrid = this.grid.cells(this.cell.parentNode.idd, 1).getSubGrid ? this.grid.cells(this.cell.parentNode.idd, 1).getSubGrid() : null;

		if (subgrid != null) {
			subgrid.forEachRow(function (id) {
				if (subgrid.cells(id, 0).isCheckbox() && (pjqABContext == 'deleteMultiple' || (subgrid.getUserData(id, "IsBlacklisted") != 'true' && subgrid.getUserData(id, "IsAutoSelectDisabled") != 'true')) && !subgrid.cells(id, 0).isDisabled()) {
					subgrid.cells(id, 0).setChecked(false);

					var subgrid2 = subgrid.cells(id, 0).getSubGrid ? this.grid.cells(id, 0).getSubGrid() : null;
					if (subgrid2 == null)
						subgrid2 = subgrid.cells(id, 1).getSubGrid ? subgrid.cells(id, 1).getSubGrid() : null;
					if (subgrid2 != null)
						subgrid2.forEachRow(function (id2) {
							if (subgrid2.cells(id2, 0).isCheckbox() && (pjqABContext == 'deleteMultiple' || (subgrid2.getUserData(id2, "IsBlacklisted") != 'true' && subgrid2.getUserData(id2, "IsAutoSelectDisabled") != 'true')) && !subgrid2.cells(id2, 0).isDisabled())
								subgrid2.cells(id2, 0).setChecked(false);
						});
				}
			});

		}
	}
	else if (a == '2')
		this.cell.chstate = "2";
	var dis = '';
	if (this.cell._disabled)
		dis = "_dis";

	var b = this;
	this.setCValue("<img src='" + this.grid.imgURL + "item_chk" + a + "a" + dis + ".gif' onclick='new eXcell_ch3(this.parentNode).changeState(true); (arguments[0]||event).cancelBubble=true; '>", this.cell.chstate)
};

function formatDate(jsonDate) {
	if (!jsonDate)
		return '';
	var date = new Date(parseInt(jsonDate.substr(6)));
	return dateFormat(date, 'mm/dd/yyyy');
}

dhtmlXGridObject.prototype._in_header_master_checkbox_abmain = function (a, b, c) {
	a.innerHTML = c[0] + "<input type='checkbox' />" + c[1];
	var d = this;
	a.getElementsByTagName("input")[0].onclick = function (a) {
		d._build_m_order();
		if (gridMain.getRowsNum() > 3000) {
			showInfoDialogAB('Selected Contacts Limit Exceeded', 'Your selection includes more than 3000 contacts.  Please limit your search and try again.', 'ui-icon-alert');
			this.checked = false;
			return;
		}
		var c = d._m_order ? d._m_order[b] : b,
			g = this.checked ? 1 : 0;
		d.forEachRowA(function (a) {
			var b = this.cells(a, c);
			var data = [],
				doRow = true;
			try {
				data = d.getUserData(a, 'SelectableContacts').split(',');
			} catch (err) {
				data = [];
			}


			if (gridMainView != 'company' || data.length > 0 && (data.length != 1 || data[0].length > 0))
				if (b.isCheckbox() && !b.isDisabled() && (pjqABContext == 'deleteMultiple' || (this.getUserData(a, 'IsBlacklisted') != 'true' && this.getUserData(a, 'IsAutoSelectDisabled') != 'true'))) {
					b.setValue(g);
					b.cell.wasChanged = !0;
					this.callEvent("onCheck", [a, c, g]);
				}
		});

		var advSearchId = '00000000-0000-0000-0000-000000000000';
		var advSearchTempId = '00000000-0000-0000-0000-000000000000';
		if (isAdvSearch) {
			advSearchId = advSearch.AddressBookSearchId;
			advSearchTempId = advSearch.AddressBookSearchTempId;
		}


		var xmlFile = '/DesktopModules/PJQAddressBook/GetContactIdList.aspx?sessionId=' + pjqSessionId;
		if (isAdvSearch) {
			if (advSearch && advSearch.AddressBookSearchId != '00000000-0000-0000-0000-000000000000')
				xmlFile += '&abs=' + advSearch.AddressBookSearchId;
			else if (advSearch && advSearch.AddressBookSearchTempId != '00000000-0000-0000-0000-000000000000')
				xmlFile += '&abst=' + advSearch.AddressBookSearchTempId;
		}

		xmlFile += '&x=' + (new Date).getTime();


		var unionFilter = getUnionFilter(),
			contactTypeFilter = getContactTypeFilter();
		if (unionFilter.length > 0) {
			xmlFile = xmlFile += '&misc=' + unionFilter;
		}
		if (contactTypeFilter.length > 0) {
			xmlFile = xmlFile += '&ct=' + contactTypeFilter;
		}

		if (pjqABContext == 'scr' && gridMainView == 'company') {
			xmlFile += '&defaultonly=1';
		}

		if (g)
			ShowBusy('Checking All...');
		else
			ShowBusy('Unchecking All...');

		jQuery.ajax({
			url: xmlFile,
			success: function (result) {
				HideBusy();
				if (g)
					CheckAllC(result);
				else
					UncheckAllC(result);
			},
			error: function (xhr, status, error) {
				HideBusy();
				showInfoDialogAB('Selection Error', "An error occurred while getting the Contact List: " + error, 'ui-icon-alert');
			}
		});

		(a || event).cancelBubble = !0;

	}
};

function masterCheckboxRowHandler(a, c, g, d) {
	var b = d.cells(a, c);
	try {
		if (state) {
			AddIfMissing(selectedGroups, d.getUserData(a, 'GroupIdList'));
		}
		else {
			RemoveIfPresent(selectedGroups, d.getUserData(a, 'GroupIdList'));
		}

	} catch (err) {
	}

	try {
		if (state) {
			AddIfMissing(selectedContacts, d.getUserData(a, 'NoGroupContactIdList'));
		}
		else {
			RemoveIfPresent(selectedContacts, d.getUserData(a, 'NoGroupContactIdList'));
		}

	} catch (err) {
	}

	try {
		if (b.isCheckbox() && !b.isDisabled() && (pjqABContext == 'deleteMultiple' || (d.getUserData(a, 'IsBlacklisted') != 'true' && d.getUserData(a, 'IsAutoSelectDisabled') != 'true')))
			b.setValue(g), b.cell.wasChanged = !0, d.callEvent("onCheck", [a, c, g])
	} catch (err) {
	}
}

dhtmlXGridObject.prototype._in_header_master_checkbox_ab = function (a, b, c) {
	a.innerHTML = c[0] + "<input type='checkbox' />" + c[1];
	var d = this;
	a.getElementsByTagName("input")[0].onclick = function (a) {
		d._build_m_order();
		var c = d._m_order ? d._m_order[b] : b,
			g = this.checked ? 1 : 0;


		d.forEachRowA(function (a) {
			masterCheckboxRowHandler(a, c, g, this)
		});


		(a || event).cancelBubble = !0;
	}
};

function CheckAllC(list) {
	HideBusy();
	if (list != null) {
		if (list.length > 0) {
			var listItems = list.split(',');
			var j = 0,
				index = -1;
			for (j = 0; j < listItems.length; j++) {
				var item = parseInt(listItems[j]);
				index = -1;

				if (item > 0 && !IsContactPreSelected(item)) {

					for (i = 0; i < selectedContacts.length; i++) {
						if (selectedContacts[i] == parseInt(listItems[j]))
							index = i;
					}
					if (index == -1 && parseInt(listItems[j]))
						selectedContacts.push(parseInt(listItems[j]));
				}
				else if (!IsGroupPreSelected(item * -1)) {
					for (i = 0; i < selectedGroups.length; i++) {
						if (selectedGroups[i] == parseInt(listItems[j]) * -1)
							index = i;
					}
					if (index == -1 && parseInt(listItems[j]))
						selectedGroups.push(parseInt(listItems[j]) * -1);
				}
			}
		}
	}
	else {
		showInfoDialogAB('Selected Contacts Limit Exceeded', 'Your selection includes more than 3000 contacts.  Please limit your search and try again.', 'ui-icon-alert');
	}
}

function UncheckAllC(list) {
	HideBusy();
	selectAllCount = 0;
	if (list.length > 0) {
		var listItems = list.split(',');
		var j = 0,
			index = -1;
		for (j = 0; j < listItems.length; j++) {
			var item = parseInt(listItems[j]);
			index = -1;
			if (item > 0) {
				for (i = 0; i < selectedContacts.length; i++) {
					if (selectedContacts[i] == parseInt(listItems[j]))
						index = i;
				}

				if (index != -1)
					selectedContacts.splice(index, 1);

			}
			else {
				for (i = 0; i < selectedGroups.length; i++) {
					if (selectedGroups[i] == parseInt(listItems[j]) * -1)
						index = i;
				}
				if (index != -1)
					selectedGroups.splice(index, 1);
			}
		}
	}
}

function ClearValidationError(id) {
	jQuery(id).removeClass('pjq-errortext');
	jQuery('label.pjq-errortext', jQuery(id).parent()).remove();
}

function SetValidationError(id, text) {
	jQuery(id).parent().append("<label class='pjq-errortext'>" + text + "</label>");
	jQuery(id).addClass('pjq-errortext');
}

function DownloadFile(path) {
	if (pjqIsIOS) {
		window.open(path);
	}
	else {
		var ifr = "<iframe src='" + path + "' frameborder='0' height='0' width='0'><a href='" + path + "'>Click here if your download does not start automatically.</a></iframe>";
		jQuery('#download-iframe').html('');
		jQuery('#download-iframe').append(ifr);
	}
}

function IsInArray(val, arr) {
	return ($.inArray(val, arr) != -1);
}

function IsContactPreSelected(contact) {
	for (var i = 0; i < settings.DisabledRowsCount; i++) {
		for (var j = 0; j < settings.DisabledRows[i].Cs.length; j++) {
			if (settings.DisabledRows[i].Cs[j].C == parseInt(contact)) {
				for (var k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
					if (settings.DisabledRows[i].Cs[j].Gs[k].Sel)
						return true;
				}
			}
		}
	}

	return false;
}

function IsGroupPreSelected(group) {
	for (var i = 0; i < settings.DisabledRowsCount; i++) {
		for (var j = 0; j < settings.DisabledRows[i].Cs.length; j++) {
			for (var k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
				if (settings.DisabledRows[i].Cs[j].Gs[k].CG == parseInt(group))
					return settings.DisabledRows[i].Cs[j].Gs[k].Sel;
			}
		}
	}

	return false;
}

function SetSubGridCheck(subgrid, state) {
	subgrid.forEachRow(function (id) {
		if ((pjqABContext == 'deleteMultiple' || (subgrid.getUserData(id, 'IsAutoSelectDisabled') != 'true' && subgrid.getUserData(id, 'IsBlacklisted') != 'true')) && !subgrid.cells(id, 0).isDisabled()) {
			if (subgrid.cells(id, 1).getSubGrid) {
				var subgrid2 = subgrid.cells(id, 1).getSubGrid();
				if (subgrid2) {
					subgrid2.forEachRow(function (id2) {
						if (subgrid2.getUserData(id2, 'IsAutoSelectDisabled') == 'true' && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
							return;
						if (subgrid2.getUserData(id2, 'IsBlacklisted') == 'true' && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge')
							return;
						if (subgrid2.cells(id2, 0).isDisabled())
							return;

						subgrid2.cells(id2, 0).setChecked(state);
						subgrid2.callEvent('onCheck', [id2, 0, state]);
					});
				}
			}
			subgrid.cells(id, 0).setChecked(state);
			subgrid.callEvent('onCheck', [id, 0, state]);
		}
	});
}

function AddIfMissing(arr, val) {
	if (!val)
		return;

	var data = val.split(',');
	for (var j = 0; j < data.length; j++) {
		var index = -1;
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] == parseInt(data[j]))
				index = i;
		}
		if (index == -1 && parseInt(data[j]))
			arr.push(parseInt(data[j]));
	}

}

function RemoveIfPresent(arr, val) {
	if (!val)
		return;

	var data = val.split(',');
	for (var j = 0; j < data.length; j++) {
		var index = -1;
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] == parseInt(data[j]))
				index = i;
		}
		if (index != -1)
			arr.splice(index, 1);
	}
}

function CheckAllTrades(sender) {
	var advSearchId = '00000000-0000-0000-0000-000000000000';
	var advSearchTempId = '00000000-0000-0000-0000-000000000000';
	if (isAdvSearch) {
		advSearchId = advSearch.AddressBookSearchId;
		advSearchTempId = advSearch.AddressBookSearchTempId;
	}

	var selectedValue = (jQuery(sender).prop('checked') ? '1' : '0');

	gridMain.forEachRow(function (id) {
		var subgrid = gridMain.cells(id, 0).getSubGrid();
		if (subgrid) {
			subgrid.forEachRow(function (id2) {
				if (subgrid.cells(id2, 0).isCheckbox && subgrid.cells(id2, 0).isCheckbox() && !subgrid.cells(id2, 0).isDisabled() && subgrid.getUserData(id2, 'IsAutoSelectDisabled') != 'true')
					subgrid.cells(id2, 0).setValue(selectedValue);
				var subgrid2 = subgrid.cells(id2, 1).getSubGrid();
				if (subgrid2) {
					subgrid2.forEachRow(function (id3) {
						if (subgrid2.cells(id3, 0).isCheckbox && subgrid2.cells(id3, 0).isCheckbox() && !subgrid2.cells(id3, 0).isDisabled() && subgrid2.getUserData(id3, 'IsAutoSelectDisabled') != 'true')
							subgrid2.cells(id3, 0).setValue(selectedValue);
					});
				}
			});
		}
	});
	var callBack = null;
	if (jQuery(sender).prop('checked')) {
		callBack = CheckAllC;
		ShowBusy('Getting Contact List...');
	}
	else {
		callBack = UncheckAllC;
		ShowBusy('Unselecting all contacts...');
	}

	var xmlFile = '/DesktopModules/PJQAddressBook/GetContactIdList.aspx?sessionId=' + pjqSessionId;
	if (isAdvSearch) {
		if (advSearch && advSearch.AddressBookSearchId != '00000000-0000-0000-0000-000000000000')
			xmlFile += '&abs=' + advSearch.AddressBookSearchId;
		else if (advSearch && advSearch.AddressBookSearchTempId != '00000000-0000-0000-0000-000000000000')
			xmlFile += '&abst=' + advSearch.AddressBookSearchTempId;
	}

	xmlFile += '&x=' + (new Date).getTime();

	var unionFilter = getUnionFilter(),
		contactTypeFilter = getContactTypeFilter();
	if (unionFilter.length > 0) {
		xmlFile += '&misc=' + unionFilter;
	}
	if (contactTypeFilter.length > 0) {
		xmlFile += '&ct=' + contactTypeFilter;
	}

	jQuery.ajax({
		url: xmlFile,
		success: function (result) {
			HideBusy();
			callBack(result);
		},
		error: function (xhr, status, error) {
			HideBusy();
			showInfoDialogAB('Selection Error', "An error occurred while getting the Contact List: " + error, 'ui-icon-alert');
		}
	});
}

function getContactTypeFilter() {
	let contactTypeFilter = 'VENDOR';
	if (settings.ContactTypes.length === 0) {
		if (isShowOwners)
			contactTypeFilter = 'OWNER';
		if (isShowArchitects) {
			contactTypeFilter = 'ARCHITECT';
		}
		if (isShowVendors) {
			contactTypeFilter = 'VENDOR';
		}
	}
	else if (!settings.IsHideContactType) {
		let id = tbMain.getListOptionSelected('usertype');
		contactTypeFilter = id.substring(id.indexOf('_') + 1);

	}
	else {
		_.each(settings.ContactTypes, function (type) {
			if (type.IsDefault) {
				contactTypeFilter = type.UserTypeId.toString();
			}
		});
	}
	return contactTypeFilter;
}

function getUnionFilter() {
	if (isShowUnion || isShowNonUnion || isShowPrevailing) {
		var laborArr = [];
		if (isShowUnion) {
			laborArr.push("union");
		}
		if (isShowNonUnion) {
			laborArr.push("nonunion");
		}
		if (isShowPrevailing) {
			laborArr.push("prevailing");
		}

		return laborArr.join(',');
	}
	return "";
}

function InitMergeContactsGridMain() {
	settings.AddressBookContext = 'merge';
	pjqABContext = 'merge';
	InitializeGridMain(gridMainView);
}

function CancelMergeContactsGridMain() {
	tbMain.tryHideItem('cancelMerge');
	tbMain.tryHideItem('cancelMerge_sep');
	settings.AddressBookContext = '';
	pjqABContext = '';
	jQuery('#top-info').hide();
	jQuery("#mergeNote").remove();
	InitializeGridMain(gridMainView);
}

var mergeResult = {};
var contactMergeGrid = null;
var lastContactMergeCount = 0;

function InitMergeContactsHelper(response) {
	mergeResult = jQuery.parseJSON(response);
	var contactRows = [];
	if (mergeResult.length == 1) {
		showInfoDialogAB('No Contacts to Merge', 'All selected contacts already belong to the same company.', 'ui-icon-alert');
		return;
	}
	for (var i = 0; i < mergeResult.length; i++) {
		for (var j = 0; j < mergeResult[i].SelectedContacts.length; j++) {
			var contactRow = [];
			contactRow.push(1);
			contactRow.push(mergeResult[i].ContactCompany.CompanyName);
			contactRow.push(mergeResult[i].SelectedContacts[j].ContactName);
			contactRow.push(mergeResult[i].ContactCompany.ContactId);
			contactRow.push(mergeResult[i].SelectedContacts[j].ContactId);
			contactRows.push(contactRow);
		}
	}
	contactMergeGrid = new dhtmlXGridObject('contactMergeGrid');
	contactMergeGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	contactMergeGrid.setSkin(pjqGridTheme);
	contactMergeGrid.enableAutoHeight(true);
	contactMergeGrid.enableAutoWidth(false);
	contactMergeGrid.setInitWidthsP('5,48,47,0,0');
	contactMergeGrid.setColAlign("center,center,center,center,center");
	contactMergeGrid.setHeader(" ,Current Company, Contact, ContactCompanyId, ContactId");
	contactMergeGrid.setColTypes("ch,ro,ro,ro,ro");
	contactMergeGrid.setColSorting("na,str,str,na,na");
	contactMergeGrid.init();
	contactMergeGrid.parse(contactRows, 'jsarray');
	jQuery('#contactMergeDialog').dialog({
		title: "Merge Contacts",
		modal: true,
		resizable: false,
		width: 600,
		dialogClass: 'contactMergeDialog',
		buttons: {
			"Merge": function () {
				var mergeContactsArr = [];
				var selectedCompanyarr = [];
				for (var i = 0; i < contactMergeGrid.getRowsNum(); i++) {
					if (parseInt(contactMergeGrid.cells2(i, 0).getValue()) == 1) {
						mergeContactsArr.push(parseInt(contactMergeGrid.cells2(i, 4).getValue()));
						if (selectedCompanyarr.indexOf(parseInt(contactMergeGrid.cells2(i, 3).getValue())) == -1)
							selectedCompanyarr.push(parseInt(contactMergeGrid.cells2(i, 3).getValue()));
					}
				}
				lastContactMergeCount = mergeContactsArr.length;
				if (lastContactMergeCount == 0) {
					showInfoDialogAB('Cannot Merge', "You must select one or more contacts to merge.", 'ui-icon-alert');
					return;
				}
				if (selectedCompanyarr.length < 2) {
					showInfoDialogAB('Cannot Merge', "You must select contacts that belong to two or more companies.", 'ui-icon-alert');
					return;
				}
				PanteraScript.PanteraScriptService.MergeContacts(pjqSessionId, parseInt(jQuery('#contactMergeCompanySelect').val()), mergeContactsArr.join('|'), MergeContactsC, onScriptError);
			},
			"Cancel": function () {
				jQuery(this).dialog('close');
				contactMergeGrid.destructor();
			}
		},
		open: function () {
			for (var i = 0; i < mergeResult.length; i++) {
				jQuery('#contactMergeCompanySelect').append("<option value='" + mergeResult[i].SelectedContacts[0].ContactId + "'>" + mergeResult[i].ContactCompany.CompanyName + "</option>");
			}
		},
		close: function () {
			jQuery('#contactMergeCompanySelect').empty();
			mergeResult = {};
		}
	});
}

function MergeContactsC(response) {
	showInfoDialogAB('Contacts Merged', lastContactMergeCount + ' contacts successfully merged.', 'ui-icon-alert');
	jQuery('#contactMergeDialog').dialog('close');
	CancelMergeContactsGridMain();
	lastContactMergeCount = 0;
	selectedContacts = [];
	selectedCompanies = [];
	selectedGroups = [];
}

function InitDeleteMultipleContactsGridMain() {
	settings.AddressBookContext = 'deleteMultiple';
	pjqABContext = 'deleteMultiple';
	InitializeGridMain(gridMainView);
}

function CancelDeleteMultipleContactsGridMain() {
	selectedContacts = [];
	tbMain.tryHideItem('cancelDeleteMultiple');
	tbMain.tryHideItem('cancelDeleteMultiple_sep');
	settings.AddressBookContext = '';
	pjqABContext = '';
	jQuery('#top-info').hide();
	jQuery("#deleteMultipleNote").remove();
	InitializeGridMain(gridMainView);
}

function DeleteSelectedContacts() {
	PanteraScript.PanteraScriptService.DeleteContacts(pjqSessionId, selectedContacts.join(','), DeleteContactsC, onScriptError);
}

function DeleteContactsC(response) {
	HideBusy();
	CancelDeleteMultipleContactsGridMain();
}

function LocationFilterChanged() {
	currentLocationFilter = parseInt(tbLocation.getListOptionSelected('location').replace('location_', ''));
}

function DirectoryFilterChanged() {
	currentDirectoryFilter = parseInt(tbSearch.getListOptionSelected('directory').replace('directory_', ''));
	if (currentDirectoryFilter !== 1) {
		tbMain.tryHideItem('merge');
		tbMain.tryHideItem('merge_sep');
		tbMain.tryHideItem('deleteMultiple');
		tbMain.tryHideItem('deleteMultiple_sep');
		tbMain.tryHideItem('new');
		tbMain.tryHideItem('new_sep');
		tbSearch.tryHideItem('adv_search');
		tbSearch.tryHideItem('adv_search_sep');
		tbSearch.tryHideItem('import');
		tbSearch.tryHideItem('import_sep');
		tbSearch.tryHideItem('export');
		tbMain.tryShowItem('labor_label');
		tbMain.tryShowItem('show_union');
		tbMain.tryShowItem('show_nonunion');
		tbMain.tryShowItem('show_prevailing');
		if (currentDirectoryFilter === 2) {
			tbLocation.tryHideItem('location_label');
			tbLocation.tryHideItem('location_sep');
			tbLocation.tryHideItem('location');
			tbLocation.tryHideItem('radius_label');
			tbLocation.tryHideItem('radius');
			tbLocation.tryHideItem('radius_sep');
		}
		else {
			tbLocation.tryShowItem('location_label');
			tbLocation.tryShowItem('location_sep');
			tbLocation.tryShowItem('location');
			tbLocation.tryShowItem('radius_label');
			tbLocation.tryShowItem('radius');
			tbLocation.tryShowItem('radius_sep');
		}
	}
	else {
		tbMain.tryShowItem('merge');
		tbMain.tryShowItem('merge_sep');
		tbMain.tryShowItem('deleteMultiple');
		tbMain.tryShowItem('deleteMultiple_sep');
		tbMain.tryShowItem('new');
		tbMain.tryShowItem('new_sep');
		tbSearch.tryShowItem('adv_search');
		tbSearch.tryShowItem('adv_search_sep');
		tbSearch.tryShowItem('import');
		tbSearch.tryShowItem('import_sep');
		tbSearch.tryShowItem('export');
		if (!settings.IsHideUnionStatus) {
			tbMain.tryShowItem('labor_label');
			tbMain.tryShowItem('show_union');
			tbMain.tryShowItem('show_nonunion');
			tbMain.tryShowItem('show_prevailing');
		}
		else {
			tbMain.tryHideItem('labor_label');
			tbMain.tryHideItem('show_union');
			tbMain.tryHideItem('show_nonunion');
			tbMain.tryHideItem('show_prevailing');
		}
		tbLocation.tryShowItem('location_label');
		tbLocation.tryShowItem('location_sep');
		tbLocation.tryShowItem('location');
		tbLocation.tryShowItem('radius_label');
		tbLocation.tryShowItem('radius');
		tbLocation.tryShowItem('radius_sep');
	}
}

function InitReportContactDialog() {
	var reportContactReasons = ["Out of business", "Wrong phone number", "Bad Email"];
	jQuery('#reportContactDialog').dialog({
		title: "Report Directory Contact",
		modal: true,
		resizable: false,
		width: 450,
		dialogClass: 'reportContactDialog',
		buttons: {
			"Report": function () {
				jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
				var reportReason = jQuery('#reportContactReason').find('option:selected').text();
				if (parseInt(jQuery('#reportContactReason').val()) == -1 || (settings.IsEnableReportPrivateContact && jQuery('#reportContactReasonOther').val().length > 0)) {
					reportReason += ': ' + jQuery('#reportContactReasonOther').val();
				}
				PanteraScript.PanteraScriptService.ReportContact(pjqSessionId, parseInt(lastContactId), reportReason, ReportContactC, onScriptError);
			},
			"Cancel": function () {
				jQuery(this).dialog('close');
			}
		},
		open: function () {
			jQuery('#reportContactReasonOther').val('');
			jQuery('#reportContactReason').empty();
			jQuery('#reportContactReason').append('<option value="">Select...</option>');
			for (var i = 0; i < reportContactReasons.length; i++) {
				jQuery('#reportContactReason').append('<option value="' + i + '">' + reportContactReasons[i] + '</option>');
			}
			jQuery('#reportContactReason').append('<option value="-1">Other</option>');
			jQuery('#reportContactReason').off();
			jQuery('#reportContactReason').on('change', function () {
				if (jQuery(this).val().length == 0) {
					jQuery('#reportContactReasonOther').hide();
					jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');

				}
				else if (parseInt(jQuery(this).val()) == -1 || currentDirectoryFilter == 1) {
					jQuery('#reportContactReasonOther').show();
					jQuery('#reportContactReasonOther').off();
					jQuery('#reportContactReasonOther').on('keyup', function () {
						if (jQuery('#reportContactReasonOther').val().length > 0)
							jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('enable');
						else
							jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
					});
					jQuery('#reportContactReasonOther').trigger('keyup');
				}
				else {
					jQuery('#reportContactReasonOther').hide();
					jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('enable');
				}
			});
			jQuery('#reportContactReason').trigger('change');
		},
		close: function () {

		}
	});
}

function ReportContactC(response) {
	jQuery('#reportContactDialog').dialog('close');
	var reportText = '';
	if (currentDirectoryFilter == 1) {
		showInfoDialogAB('Contact Reported', 'The selected contact has been reported and will be reviewed by an administrator.', 'ui-icon-info');
	}
	else {
		showInfoDialogAB('Contact Reported', 'The selected contact has been reported to customer service and removed from your address book.', 'ui-icon-info', 'report-contact');
	}

}

var prequalRequestContactId = 0;

function RequestContactPrequalificationHelper(thisRequestContactId) {
	prequalRequestContactId = thisRequestContactId;
	showInfoDialogAB('Send Contact Updater', 'Are you sure you want to send this contact a prequalification request?', 'ui-icon-alert', 'request-prequal');
}

function RequestContactPrequalification() {
	PanteraScript.PanteraScriptService.RequestContactPrequalification(pjqSessionId, prequalRequestContactId, RequestContactPrequalificationC, onScriptError);
}

function RequestContactPrequalificationC(response) {
	var pResult = jQuery.parseJSON(response);
	if (pResult.Result)
		showInfoDialogAB('Prequalification Request Sent', 'A prequalification request has been sent to the selected contact.  ', 'ui-icon-info');
	else {
		var failureReason = "";
		if (pResult.ResultNote == "noEmail")
			failureReason = "The selected contact does not have an email address.  Please add one and try again.";
		else if (pResult.ResultNote == "badEmail")
			failureReason = "The selected contact's email address is opted out'.  Please update it and try again, or contact customer service if you believe this to be incorrect.";

		showInfoDialogAB('Prequalification Request Not Sent', failureReason, 'ui-icon-info');
	}
}

dhtmlXToolbarObject.prototype.tryShowItem = function (item) {
	try {
		this.showItem(item);
	} catch (err) {
	}
};

dhtmlXToolbarObject.prototype.tryHideItem = function (item) {
	try {
		this.hideItem(item);
	} catch (err) {
	}
};

dhtmlXToolbarObject.prototype.tryEnableItem = function (item) {
	try {
		this.enableItem(item);
	} catch (err) {
	}
};

dhtmlXToolbarObject.prototype.tryDisableItem = function (item) {
	try {
		this.disableItem(item);
	} catch (err) {
	}
};

function subGridXLE(id) {
	var i = 0,
		j = 0,
		k = 0,
		selectedCount = 0,
		selectableCount = 0;
	var counter = 0;
	var sub_grid_obj = this;

	if (gridMainView == 'group') {
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_COLOR_COLUMNS)) {
			let colorCodePref = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_COLOR_COLUMNS),
				colorCols = $.parseJSON(colorCodePref),
				colorCol = colorCols.sub.company;
			if (settings.AddressBookContext == 'ap2' || settings.AddressBookContext == 'ap3') {
				colorCol = colorCols.sub.projectContext;
			}
			switch (sub_grid_obj.cells(id, colorCol).getValue().toLowerCase()) {
				case 'green':
					sub_grid_obj.setRowColor(id, '#37DA5E');
					break;
				case 'blue':
					sub_grid_obj.setRowColor(id, '#A2ADF9');
					break;
				case 'red':
					sub_grid_obj.setRowColor(id, '#F57C7C');
					break;
				case 'yellow':
					sub_grid_obj.setRowColor(id, '#FCFF80');
					break;
				case 'purple':
					sub_grid_obj.setRowColor(id, '#E4A0E0');
					break;
				case 'orange':
					sub_grid_obj.setRowColor(id, '#FC8');
					break;
			}
		}

		var companyGroups = sub_grid_obj.getUserData(id, 'GroupIdList').split(',');
		if (companyGroups[0] == '')
			companyGroups = [];
		selectableCount = companyGroups.length;
		if (companyGroups && companyGroups.length == 1 && companyGroups[0] == '')
			selectableCount = 0;

		for (i = 0; i < companyGroups.length; i++) {
			if ($.inArray(parseInt(companyGroups[i]), selectedGroups) != -1)
				counter++;
			if (IsGroupPreSelected(companyGroups[i]))
				selectedCount++;
		}
		var companyGroups2 = sub_grid_obj.getUserData(id, 'NoGroupContactIdList').split(',');
		if (companyGroups2[0] == '')
			companyGroups2 = [];
		selectableCount += companyGroups2.length;
		if (companyGroups2 && companyGroups2.length == 1 && companyGroups2[0] == '')
			selectableCount -= 1;

		var unselectableCount = 0;
		if (sub_grid_obj.getUserData(id, 'SelectableContacts').length > 0 && sub_grid_obj.getUserData(id, 'SelectableContacts').split(',').length != parseInt(sub_grid_obj.getUserData(id, 'ContactCount'))) {
			unselectableCount = (parseInt(sub_grid_obj.getUserData(id, 'ContactCount')) - sub_grid_obj.getUserData(id, 'SelectableContacts').split(',').length);
		}

		for (i = 0; i < companyGroups2.length; i++) {
			if ($.inArray(parseInt(companyGroups2[i]), selectedContacts) != -1)
				counter++;
			if (IsContactPreSelected(companyGroups2[i]))
				selectedCount++;
		}
		if ($.inArray(parseInt(id), selectedCompanies) != -1)
			sub_grid_obj.cells(id, 0).setChecked(true);
		else if (counter + selectedCount == selectableCount && selectableCount > 0 && unselectableCount == 0)
			sub_grid_obj.cells(id, 0).setChecked(true);
		else if (counter + selectedCount > 0)
			sub_grid_obj.cells(id, 0).setValue('2');

		if (selectedCount > 0 && counter == 0 && selectedCount == selectableCount)
			sub_grid_obj.cells(id, 0).setDisabled(true);
		else if (unselectableCount > 0 && sub_grid_obj.getUserData(id, 'SelectableContacts').length == 0)
			sub_grid_obj.cells(id, 0).setDisabled(true);

		if (selectedCount + counter > 0 && selectedCount + counter == selectableCount) {
			var subgrid = sub_grid_obj.cells(id, 1).getSubGrid();
			if (subgrid)
				subgrid.forEachRow(function (id2) {
					for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
						if (settings.DisabledRows[i].Cs[j].Gs[k].G == subgrid.getUserData(id2, "GroupId"))
							subgrid.cells(id2, 0).setChecked(true);
					}
				});
		}

		if (sub_grid_obj.getUserData(id, 'IsBlacklisted') == 'true') {
			if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge') {
				sub_grid_obj.cells(id, 0).setChecked(false);
				sub_grid_obj.cells(id, 0).setDisabled(true);
			}
			sub_grid_obj.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
		}


		if (sub_grid_obj.getUserData(id, 'SelectableContacts') == '') {
			sub_grid_obj.cells(id, 0).setDisabled(true);
		}

	}
	else if (gridMainView == 'company') {
		for (i = 0; i < settings.DisabledRowsCount; i++) {
			for (j = 0; j < settings.DisabledRows[i].Cs.length; j++) {
				if (settings.DisabledRows[i].Cs[j].C == parseInt(id)) {

					for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
						if (settings.DisabledRows[i].Cs[j].Gs[k].Sel || settings.DisabledRows[i].Cs[j].Gs[k].G == 0) {
							selectedCount += 1;
						}
					}
					if (selectedCount > 0 && selectedCount == settings.DisabledRows[i].Cs[j].Gs.length) {
						sub_grid_obj.cells(id, 0).setDisabled(true);
						sub_grid_obj.cells(id, 0).setChecked(true);
						var subgrid = sub_grid_obj.cells(id, 1).getSubGrid();
						if (subgrid)
							subgrid.forEachRow(function (id2) {
								for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
									if (settings.DisabledRows[i].Contacts[j].Gs[k].G == subgrid.getUserData(id2, "GroupId"))
										subgrid.cells(id2, 0).setChecked(true);
								}
							});
					}
					else if (selectedCount > 0) {
						sub_grid_obj.cells(id, 0).setValue('2');
					}
				}
			}
		}

		var companyGroups = sub_grid_obj.getUserData(id, 'GroupIdList').split(',');
		for (i = 0; i < companyGroups.length; i++) {
			if ($.inArray(parseInt(companyGroups[i]), selectedGroups) != -1)
				sub_grid_obj.cells(id, 0).setChecked(true);
		}

		if (sub_grid_obj.getUserData(id, 'IsBlacklisted') == 'true') {
			if (pjqABContext.length > 0 && pjqABContext != 'deleteMultiple' && pjqABContext != 'merge') {
				sub_grid_obj.cells(id, 0).setChecked(false);
				sub_grid_obj.cells(id, 0).setDisabled(true);
			}
			sub_grid_obj.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
		}


	}
	else if (gridMainView == 'contact') {
		for (i = 0; i < settings.DisabledRowsCount; i++) {
			for (j = 0; j < settings.DisabledRows[i].Cs.length; j++) {
				if (settings.DisabledRows[i].Cs[j].C == sub_grid_obj.getUserData(id, "ContactId")) {
					for (k = 0; k < settings.DisabledRows[i].Cs[j].Gs.length; k++) {
						if ((settings.DisabledRows[i].Cs[j].Gs[k].Sel && settings.DisabledRows[i].Cs[j].Gs[k].CG == parseInt(id)) || settings.DisabledRows[i].Cs[j].Gs[k].G == 0) {
							sub_grid_obj.cells(id, 0).setDisabled(true);
							sub_grid_obj.cells(id, 0).setChecked(true);
						}
					}
				}

			}
		}
	}

	if (gridMainView == 'contact' && IsInArray(parseInt(id), selectedGroups) && pjqABContext.length > 0)
		sub_grid_obj.cells(id, 0).setChecked(true);

}

dhtmlXGridObject.prototype._in_header_master_checkbox_abapprove = function (a, b, c) {
	a.innerHTML = c[0] + "<input type='checkbox' />" + c[1];
	var d = this;
	a.getElementsByTagName("input")[0].onclick = function (a) {
		d._build_m_order();
		var c = d._m_order ? d._m_order[b] : b,
			g = this.checked ? 1 : 0;
		d.forEachRowA(function (a) {
			var b = this.cells(a, c);
			if (b.isCheckbox() && !b.isDisabled())
				b.setValue(g), b.cell.wasChanged = !0;
			this.callEvent("onEditCell", [1, a, c, g]);
			this.callEvent("onCheckbox", [a, c, g])
		});

		if (gridContactUpdates.getCheckedRows(0).length > 0)
			jQuery('#copyApproveChangesButton').button('enable');
		else
			jQuery('#copyApproveChangesButton').button('disable');

		(a || event).cancelBubble = !0;
	}
};

function getContactInfo(contactId) {
	if (settings.ShouldUseOldGroupSelector) {
		PanteraScript.PanteraScriptService.GetContactInfoAB(pjqSessionId, parseInt(contactId), (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval'), function (response) {
			InitializeEdit($.parseJSON(response));
		}, onScriptError);
	}
	else {
		new PJQ.ajax.Request({
			endpoint: "/Contact/GetContactInfo",
			isPascal: true,
			data: {
				contactId: parseInt(contactId),
				isApprovalRequired: (settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval')
			}
		}).post().done(function (data) {
			InitializeEdit(data);
		}).fail(function () {
		});
	}
}

function InitializeEdit(contact) {
	if (typeof window.initAbEditCallback === 'function') {
		window.initAbEditCallback(true);
	}

	if (contact.UnapprovedChangeCount == 0) {
		let template = 'EditContact',
			sessionMasterUserId = PJQ.app.session.get('masterUserId');
		if (sessionMasterUserId === 129103) {
			template += '_129103';
		}
		else if (sessionMasterUserId === 131068) {
			template += '_131068';
		}

		contact.IsABRequiredFields = settings.IsABRequiredFields;
		contact.IsAddressRequired = settings.IsAddressRequired;
		contact.IsPostalCodeRequired = settings.IsPostalCodeRequired;
		contact.IsContactInfoRequired = settings.IsContactInfoRequired;
		contact.IsABRequiredFieldsCore = settings.IsABRequiredFieldsCore;
		contact.IsCustomFieldsRequired = settings.IsCustomFieldsRequired;
		contact.IsCompanyCustomFieldsRequired = settings.IsCompanyCustomFieldsRequired;
		contact.IsUnionStatusRequired = settings.IsUnionStatusRequired;
		contact.IsShowUnionStatus = settings.IsShowUnionStatus;

		PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, template, {
			isOldModule: true,
			isJsRender: true
		}), jQuery("#divEdit"), contact, function () {
			SetInputStyles("#divEdit");
			PJQAddressBookContactEditInitialize(contact);
			jQuery("#divGrid").addClass('pjq-hidden');
			jQuery("#divEdit").removeClass('pjq-hidden');
		});
	}
	else {
		lastContactId = contact.ContactId;
		InitializeApproveChanges(contact.ContactId);
	}
}

var gridContactUpdates = null;

function InitializeApproveChanges(contactId) {
	jQuery("#divGrid").addClass('pjq-hidden');
	jQuery("#divApproveChanges").removeClass('pjq-hidden');

	if (null == gridContactUpdates) {
		gridContactUpdates = new dhtmlXGridObject('grid-contact-updates');
		gridContactUpdates.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
		gridContactUpdates.enableAutoHeight(true);
		gridContactUpdates.init();
		gridContactUpdates.attachEvent("onCheck", function (rId, cInd, state) {
			if (gridContactUpdates.getCheckedRows(0).length > 0)
				jQuery('#copyApproveChangesButton').button('enable');
			else
				jQuery('#copyApproveChangesButton').button('disable');
		});

	}
	else {
		gridContactUpdates.clearAll();
	}

	gridContactUpdates.load('/DesktopModules/PJQAddressBook/GetContactUpdatesApproval.aspx?sessionid=' + pjqSessionId + '&c=' + contactId.toString(), function () {
		jQuery('#approve-changes-title').text("Approve Contact Edits - " + gridContactUpdates.getUserData(null, 'Title'));
	});
	jQuery('#approve-changes-commands button').button();
	jQuery('#copyApproveChangesButton').button('disable');
}

function copyApproveChanges() {
	var totalRows = gridContactUpdates.getRowsNum();
	var checkedRows = gridContactUpdates.getCheckedRows(0).length == 0 ? 0 : gridContactUpdates.getCheckedRows(0).split(',').length;
	showInfoDialogAB('Copy Changes', 'Do you want to Copy ' + checkedRows.toString() + ' out of ' + totalRows.toString() + ' changes to a New Contact?  The original Contact will remain the same, and any unchecked items will be discarded.', 'ui-icon-alert', 'copy-change-list');
}

function applyApproveChanges() {
	var totalRows = gridContactUpdates.getRowsNum();
	var checkedRows = gridContactUpdates.getCheckedRows(0).length == 0 ? 0 : gridContactUpdates.getCheckedRows(0).split(',').length;
	showInfoDialogAB('Approve Changes', 'Do you want to Approve ' + checkedRows.toString() + ' out of ' + totalRows.toString() + ' changes?', 'ui-icon-alert', 'approve-change-list');
}

var approvedChanges = null, unapprovedChanges = null;

function applyApproveChanges2() {
	approvedChanges = [];
	unapprovedChanges = [];
	gridContactUpdates.forEachRow(function (id) {
		if (gridContactUpdates.cells(id, 0).isChecked())
			approvedChanges.push(id);
		else
			unapprovedChanges.push(id);
	});
	PanteraScript.PanteraScriptService.ApplyContactUpdates(pjqSessionId, lastContactId, approvedChanges.join(','), unapprovedChanges.join(','), applyApproveChangesC, onScriptError);
}

function copyApproveChanges2() {
	approvedChanges = [];
	unapprovedChanges = [];
	gridContactUpdates.forEachRow(function (id) {
		if (gridContactUpdates.cells(id, 0).isChecked())
			approvedChanges.push(id);
		else
			unapprovedChanges.push(id);
	});
	PanteraScript.PanteraScriptService.CopyContactUpdates(pjqSessionId, lastContactId, approvedChanges.join(','), unapprovedChanges.join(','), applyApproveChangesC, onScriptError);
}

function applyApproveChangesC(response) {
	cancelApproveChanges();
	if (settings.CountNeedsApproval > 0) {
		settings.CountNeedsApproval--;
		tbMain.setListOptionText('view_approval_default', 'view_needs_approval', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
		tbMain.setItemText('view_approval_default', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
	}

	InitializeGridMain(gridMainView);
}

function cancelApproveChanges() {
	jQuery("#divApproveChanges").addClass('pjq-hidden');
	jQuery('#approve-changes-title').text("Approve Contact Edits");
	gridContactUpdates.clearAll();
	jQuery("#divGrid").removeClass('pjq-hidden');
}

function viewApproval() {
	tbMain.setListOptionSelected('view_approval_default', 'view_needs_approval');
	tbMain.setItemText("view_approval_default", "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
	InitializeGridMain(gridMainView);
}
